export default {
    "scalars": [
        0,
        2,
        4,
        7,
        9,
        15,
        23,
        27,
        29,
        34,
        37,
        38,
        49,
        60,
        63,
        68,
        71,
        79,
        86,
        89,
        90,
        93,
        96,
        99,
        109,
        113,
        121,
        124,
        135,
        142,
        150,
        153,
        154,
        156,
        161,
        164,
        165,
        167,
        170,
        184,
        190,
        200,
        208,
        224,
        225,
        226,
        238,
        246,
        252,
        260,
        267,
        287,
        329,
        348,
        361,
        366,
        368,
        375,
        384,
        392,
        407,
        419,
        431,
        439,
        457,
        466,
        474,
        494,
        505,
        523,
        531,
        543,
        544,
        545,
        564,
        569,
        574,
        576,
        578,
        580,
        584,
        590,
        593,
        594,
        596
    ],
    "types": {
        "Boolean": {},
        "Boolean_comparison_exp": {
            "_eq": [
                0
            ],
            "_gt": [
                0
            ],
            "_gte": [
                0
            ],
            "_in": [
                0
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                0
            ],
            "_lte": [
                0
            ],
            "_neq": [
                0
            ],
            "_nin": [
                0
            ],
            "__typename": [
                7
            ]
        },
        "Float": {},
        "GeneralOutput": {
            "data": [
                99
            ],
            "error": [
                99
            ],
            "__typename": [
                7
            ]
        },
        "Int": {},
        "Int_comparison_exp": {
            "_eq": [
                4
            ],
            "_gt": [
                4
            ],
            "_gte": [
                4
            ],
            "_in": [
                4
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                4
            ],
            "_lte": [
                4
            ],
            "_neq": [
                4
            ],
            "_nin": [
                4
            ],
            "__typename": [
                7
            ]
        },
        "SampleOutput": {
            "data": [
                7
            ],
            "error": [
                7
            ],
            "__typename": [
                7
            ]
        },
        "String": {},
        "String_comparison_exp": {
            "_eq": [
                7
            ],
            "_gt": [
                7
            ],
            "_gte": [
                7
            ],
            "_ilike": [
                7
            ],
            "_in": [
                7
            ],
            "_iregex": [
                7
            ],
            "_is_null": [
                0
            ],
            "_like": [
                7
            ],
            "_lt": [
                7
            ],
            "_lte": [
                7
            ],
            "_neq": [
                7
            ],
            "_nilike": [
                7
            ],
            "_nin": [
                7
            ],
            "_niregex": [
                7
            ],
            "_nlike": [
                7
            ],
            "_nregex": [
                7
            ],
            "_nsimilar": [
                7
            ],
            "_regex": [
                7
            ],
            "_similar": [
                7
            ],
            "__typename": [
                7
            ]
        },
        "address_verification_status": {},
        "address_verification_status_comparison_exp": {
            "_eq": [
                9
            ],
            "_gt": [
                9
            ],
            "_gte": [
                9
            ],
            "_in": [
                9
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                9
            ],
            "_lte": [
                9
            ],
            "_neq": [
                9
            ],
            "_nin": [
                9
            ],
            "__typename": [
                7
            ]
        },
        "addresses": {
            "Buyer": [
                31
            ],
            "CityData": [
                566
            ],
            "Route_step": [
                517,
                {
                    "distinct_on": [
                        523,
                        "[shipments_routes_steps_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        522,
                        "[shipments_routes_steps_order_by!]"
                    ],
                    "where": [
                        519
                    ]
                }
            ],
            "Seller": [
                306
            ],
            "Shipments": [
                441,
                {
                    "distinct_on": [
                        543,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        497,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        452
                    ]
                }
            ],
            "Shipments_aggregate": [
                442,
                {
                    "distinct_on": [
                        543,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        497,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        452
                    ]
                }
            ],
            "Undefined_buyer": [
                582
            ],
            "buyer_id": [
                596
            ],
            "city": [
                564
            ],
            "description": [
                7
            ],
            "id": [
                596
            ],
            "location": [
                96
            ],
            "name": [
                7
            ],
            "seller_id": [
                596
            ],
            "undefined_buyer_id": [
                596
            ],
            "verification_status": [
                9
            ],
            "__typename": [
                7
            ]
        },
        "addresses_aggregate_order_by": {
            "count": [
                164
            ],
            "max": [
                17
            ],
            "min": [
                18
            ],
            "__typename": [
                7
            ]
        },
        "addresses_arr_rel_insert_input": {
            "data": [
                16
            ],
            "on_conflict": [
                20
            ],
            "__typename": [
                7
            ]
        },
        "addresses_bool_exp": {
            "Buyer": [
                32
            ],
            "CityData": [
                567
            ],
            "Route_step": [
                519
            ],
            "Seller": [
                308
            ],
            "Shipments": [
                452
            ],
            "Shipments_aggregate": [
                443
            ],
            "Undefined_buyer": [
                583
            ],
            "_and": [
                14
            ],
            "_not": [
                14
            ],
            "_or": [
                14
            ],
            "buyer_id": [
                598
            ],
            "city": [
                565
            ],
            "description": [
                8
            ],
            "id": [
                598
            ],
            "location": [
                98
            ],
            "name": [
                8
            ],
            "seller_id": [
                598
            ],
            "undefined_buyer_id": [
                598
            ],
            "verification_status": [
                10
            ],
            "__typename": [
                7
            ]
        },
        "addresses_constraint": {},
        "addresses_insert_input": {
            "Undefined_buyer": [
                587
            ],
            "buyer_id": [
                596
            ],
            "city": [
                564
            ],
            "description": [
                7
            ],
            "id": [
                596
            ],
            "location": [
                96
            ],
            "name": [
                7
            ],
            "undefined_buyer_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "addresses_max_order_by": {
            "buyer_id": [
                164
            ],
            "city": [
                164
            ],
            "description": [
                164
            ],
            "id": [
                164
            ],
            "name": [
                164
            ],
            "seller_id": [
                164
            ],
            "undefined_buyer_id": [
                164
            ],
            "verification_status": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "addresses_min_order_by": {
            "buyer_id": [
                164
            ],
            "city": [
                164
            ],
            "description": [
                164
            ],
            "id": [
                164
            ],
            "name": [
                164
            ],
            "seller_id": [
                164
            ],
            "undefined_buyer_id": [
                164
            ],
            "verification_status": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "addresses_mutation_response": {
            "affected_rows": [
                4
            ],
            "returning": [
                11
            ],
            "__typename": [
                7
            ]
        },
        "addresses_on_conflict": {
            "constraint": [
                15
            ],
            "update_columns": [
                27
            ],
            "where": [
                14
            ],
            "__typename": [
                7
            ]
        },
        "addresses_order_by": {
            "Buyer": [
                33
            ],
            "CityData": [
                568
            ],
            "Route_step_aggregate": [
                518
            ],
            "Seller": [
                314
            ],
            "Shipments_aggregate": [
                448
            ],
            "Undefined_buyer": [
                589
            ],
            "buyer_id": [
                164
            ],
            "city": [
                164
            ],
            "description": [
                164
            ],
            "id": [
                164
            ],
            "location": [
                164
            ],
            "name": [
                164
            ],
            "seller_id": [
                164
            ],
            "undefined_buyer_id": [
                164
            ],
            "verification_status": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "addresses_pk_columns_input": {
            "id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "addresses_select_column": {},
        "addresses_set_input": {
            "description": [
                7
            ],
            "location": [
                96
            ],
            "__typename": [
                7
            ]
        },
        "addresses_stream_cursor_input": {
            "initial_value": [
                26
            ],
            "ordering": [
                37
            ],
            "__typename": [
                7
            ]
        },
        "addresses_stream_cursor_value_input": {
            "buyer_id": [
                596
            ],
            "city": [
                564
            ],
            "description": [
                7
            ],
            "id": [
                596
            ],
            "location": [
                96
            ],
            "name": [
                7
            ],
            "seller_id": [
                596
            ],
            "undefined_buyer_id": [
                596
            ],
            "verification_status": [
                9
            ],
            "__typename": [
                7
            ]
        },
        "addresses_update_column": {},
        "addresses_updates": {
            "_set": [
                24
            ],
            "where": [
                14
            ],
            "__typename": [
                7
            ]
        },
        "bigint": {},
        "bigint_comparison_exp": {
            "_eq": [
                29
            ],
            "_gt": [
                29
            ],
            "_gte": [
                29
            ],
            "_in": [
                29
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                29
            ],
            "_lte": [
                29
            ],
            "_neq": [
                29
            ],
            "_nin": [
                29
            ],
            "__typename": [
                7
            ]
        },
        "buyers": {
            "Addresses": [
                11,
                {
                    "distinct_on": [
                        23,
                        "[addresses_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        21,
                        "[addresses_order_by!]"
                    ],
                    "where": [
                        14
                    ]
                }
            ],
            "Shipments": [
                441,
                {
                    "distinct_on": [
                        543,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        497,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        452
                    ]
                }
            ],
            "Shipments_aggregate": [
                442,
                {
                    "distinct_on": [
                        543,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        497,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        452
                    ]
                }
            ],
            "has_whatsapp": [
                0
            ],
            "id": [
                596
            ],
            "image_id": [
                596
            ],
            "name": [
                7
            ],
            "phone_number": [
                7
            ],
            "__typename": [
                7
            ]
        },
        "buyers_bool_exp": {
            "Addresses": [
                14
            ],
            "Shipments": [
                452
            ],
            "Shipments_aggregate": [
                443
            ],
            "_and": [
                32
            ],
            "_not": [
                32
            ],
            "_or": [
                32
            ],
            "has_whatsapp": [
                1
            ],
            "id": [
                598
            ],
            "image_id": [
                598
            ],
            "name": [
                8
            ],
            "phone_number": [
                8
            ],
            "__typename": [
                7
            ]
        },
        "buyers_order_by": {
            "Addresses_aggregate": [
                12
            ],
            "Shipments_aggregate": [
                448
            ],
            "has_whatsapp": [
                164
            ],
            "id": [
                164
            ],
            "image_id": [
                164
            ],
            "name": [
                164
            ],
            "phone_number": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "buyers_select_column": {},
        "buyers_stream_cursor_input": {
            "initial_value": [
                36
            ],
            "ordering": [
                37
            ],
            "__typename": [
                7
            ]
        },
        "buyers_stream_cursor_value_input": {
            "has_whatsapp": [
                0
            ],
            "id": [
                596
            ],
            "image_id": [
                596
            ],
            "name": [
                7
            ],
            "phone_number": [
                7
            ],
            "__typename": [
                7
            ]
        },
        "cursor_ordering": {},
        "dimensions_cm_scalar": {},
        "dimensions_cm_scalar_comparison_exp": {
            "_eq": [
                38
            ],
            "_gt": [
                38
            ],
            "_gte": [
                38
            ],
            "_in": [
                38
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                38
            ],
            "_lte": [
                38
            ],
            "_neq": [
                38
            ],
            "_nin": [
                38
            ],
            "__typename": [
                7
            ]
        },
        "drivers": {
            "Assigned_shipments": [
                441,
                {
                    "distinct_on": [
                        543,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        497,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        452
                    ]
                }
            ],
            "Assigned_shipments_aggregate": [
                442,
                {
                    "distinct_on": [
                        543,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        497,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        452
                    ]
                }
            ],
            "Locations": [
                42,
                {
                    "distinct_on": [
                        49,
                        "[drivers_locations_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        48,
                        "[drivers_locations_order_by!]"
                    ],
                    "where": [
                        45
                    ]
                }
            ],
            "has_whatsapp": [
                0
            ],
            "id": [
                596
            ],
            "image_id": [
                596
            ],
            "name": [
                7
            ],
            "phone_number": [
                7
            ],
            "__typename": [
                7
            ]
        },
        "drivers_bool_exp": {
            "Assigned_shipments": [
                452
            ],
            "Assigned_shipments_aggregate": [
                443
            ],
            "Locations": [
                45
            ],
            "_and": [
                41
            ],
            "_not": [
                41
            ],
            "_or": [
                41
            ],
            "has_whatsapp": [
                1
            ],
            "id": [
                598
            ],
            "image_id": [
                598
            ],
            "name": [
                8
            ],
            "phone_number": [
                8
            ],
            "__typename": [
                7
            ]
        },
        "drivers_locations": {
            "Driver": [
                40
            ],
            "altitude": [
                71
            ],
            "altitude_accuracy": [
                71
            ],
            "bearing_string": [
                7
            ],
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "driver_id": [
                596
            ],
            "id": [
                596
            ],
            "latitude": [
                156
            ],
            "location": [
                96
            ],
            "location_accuracy_radius": [
                71
            ],
            "location_recorded_time_unix": [
                29
            ],
            "longitude": [
                156
            ],
            "route_id": [
                596
            ],
            "simulated": [
                0
            ],
            "speed": [
                71
            ],
            "__typename": [
                7
            ]
        },
        "drivers_locations_aggregate_order_by": {
            "avg": [
                44
            ],
            "count": [
                164
            ],
            "max": [
                46
            ],
            "min": [
                47
            ],
            "stddev": [
                50
            ],
            "stddev_pop": [
                51
            ],
            "stddev_samp": [
                52
            ],
            "sum": [
                55
            ],
            "var_pop": [
                56
            ],
            "var_samp": [
                57
            ],
            "variance": [
                58
            ],
            "__typename": [
                7
            ]
        },
        "drivers_locations_avg_order_by": {
            "altitude": [
                164
            ],
            "altitude_accuracy": [
                164
            ],
            "latitude": [
                164
            ],
            "location_accuracy_radius": [
                164
            ],
            "location_recorded_time_unix": [
                164
            ],
            "longitude": [
                164
            ],
            "speed": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "drivers_locations_bool_exp": {
            "Driver": [
                41
            ],
            "_and": [
                45
            ],
            "_not": [
                45
            ],
            "_or": [
                45
            ],
            "altitude": [
                72
            ],
            "altitude_accuracy": [
                72
            ],
            "bearing_string": [
                8
            ],
            "date_created": [
                579
            ],
            "date_updated": [
                579
            ],
            "driver_id": [
                598
            ],
            "id": [
                598
            ],
            "latitude": [
                157
            ],
            "location": [
                98
            ],
            "location_accuracy_radius": [
                72
            ],
            "location_recorded_time_unix": [
                30
            ],
            "longitude": [
                157
            ],
            "route_id": [
                598
            ],
            "simulated": [
                1
            ],
            "speed": [
                72
            ],
            "__typename": [
                7
            ]
        },
        "drivers_locations_max_order_by": {
            "altitude": [
                164
            ],
            "altitude_accuracy": [
                164
            ],
            "bearing_string": [
                164
            ],
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "driver_id": [
                164
            ],
            "id": [
                164
            ],
            "latitude": [
                164
            ],
            "location_accuracy_radius": [
                164
            ],
            "location_recorded_time_unix": [
                164
            ],
            "longitude": [
                164
            ],
            "route_id": [
                164
            ],
            "speed": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "drivers_locations_min_order_by": {
            "altitude": [
                164
            ],
            "altitude_accuracy": [
                164
            ],
            "bearing_string": [
                164
            ],
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "driver_id": [
                164
            ],
            "id": [
                164
            ],
            "latitude": [
                164
            ],
            "location_accuracy_radius": [
                164
            ],
            "location_recorded_time_unix": [
                164
            ],
            "longitude": [
                164
            ],
            "route_id": [
                164
            ],
            "speed": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "drivers_locations_order_by": {
            "Driver": [
                59
            ],
            "altitude": [
                164
            ],
            "altitude_accuracy": [
                164
            ],
            "bearing_string": [
                164
            ],
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "driver_id": [
                164
            ],
            "id": [
                164
            ],
            "latitude": [
                164
            ],
            "location": [
                164
            ],
            "location_accuracy_radius": [
                164
            ],
            "location_recorded_time_unix": [
                164
            ],
            "longitude": [
                164
            ],
            "route_id": [
                164
            ],
            "simulated": [
                164
            ],
            "speed": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "drivers_locations_select_column": {},
        "drivers_locations_stddev_order_by": {
            "altitude": [
                164
            ],
            "altitude_accuracy": [
                164
            ],
            "latitude": [
                164
            ],
            "location_accuracy_radius": [
                164
            ],
            "location_recorded_time_unix": [
                164
            ],
            "longitude": [
                164
            ],
            "speed": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "drivers_locations_stddev_pop_order_by": {
            "altitude": [
                164
            ],
            "altitude_accuracy": [
                164
            ],
            "latitude": [
                164
            ],
            "location_accuracy_radius": [
                164
            ],
            "location_recorded_time_unix": [
                164
            ],
            "longitude": [
                164
            ],
            "speed": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "drivers_locations_stddev_samp_order_by": {
            "altitude": [
                164
            ],
            "altitude_accuracy": [
                164
            ],
            "latitude": [
                164
            ],
            "location_accuracy_radius": [
                164
            ],
            "location_recorded_time_unix": [
                164
            ],
            "longitude": [
                164
            ],
            "speed": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "drivers_locations_stream_cursor_input": {
            "initial_value": [
                54
            ],
            "ordering": [
                37
            ],
            "__typename": [
                7
            ]
        },
        "drivers_locations_stream_cursor_value_input": {
            "altitude": [
                71
            ],
            "altitude_accuracy": [
                71
            ],
            "bearing_string": [
                7
            ],
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "driver_id": [
                596
            ],
            "id": [
                596
            ],
            "latitude": [
                156
            ],
            "location": [
                96
            ],
            "location_accuracy_radius": [
                71
            ],
            "location_recorded_time_unix": [
                29
            ],
            "longitude": [
                156
            ],
            "route_id": [
                596
            ],
            "simulated": [
                0
            ],
            "speed": [
                71
            ],
            "__typename": [
                7
            ]
        },
        "drivers_locations_sum_order_by": {
            "altitude": [
                164
            ],
            "altitude_accuracy": [
                164
            ],
            "latitude": [
                164
            ],
            "location_accuracy_radius": [
                164
            ],
            "location_recorded_time_unix": [
                164
            ],
            "longitude": [
                164
            ],
            "speed": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "drivers_locations_var_pop_order_by": {
            "altitude": [
                164
            ],
            "altitude_accuracy": [
                164
            ],
            "latitude": [
                164
            ],
            "location_accuracy_radius": [
                164
            ],
            "location_recorded_time_unix": [
                164
            ],
            "longitude": [
                164
            ],
            "speed": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "drivers_locations_var_samp_order_by": {
            "altitude": [
                164
            ],
            "altitude_accuracy": [
                164
            ],
            "latitude": [
                164
            ],
            "location_accuracy_radius": [
                164
            ],
            "location_recorded_time_unix": [
                164
            ],
            "longitude": [
                164
            ],
            "speed": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "drivers_locations_variance_order_by": {
            "altitude": [
                164
            ],
            "altitude_accuracy": [
                164
            ],
            "latitude": [
                164
            ],
            "location_accuracy_radius": [
                164
            ],
            "location_recorded_time_unix": [
                164
            ],
            "longitude": [
                164
            ],
            "speed": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "drivers_order_by": {
            "Assigned_shipments_aggregate": [
                448
            ],
            "Locations_aggregate": [
                43
            ],
            "has_whatsapp": [
                164
            ],
            "id": [
                164
            ],
            "image_id": [
                164
            ],
            "name": [
                164
            ],
            "phone_number": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "drivers_select_column": {},
        "drivers_stream_cursor_input": {
            "initial_value": [
                62
            ],
            "ordering": [
                37
            ],
            "__typename": [
                7
            ]
        },
        "drivers_stream_cursor_value_input": {
            "has_whatsapp": [
                0
            ],
            "id": [
                596
            ],
            "image_id": [
                596
            ],
            "name": [
                7
            ],
            "phone_number": [
                7
            ],
            "__typename": [
                7
            ]
        },
        "env_variable_type": {},
        "env_variable_type_comparison_exp": {
            "_eq": [
                63
            ],
            "_gt": [
                63
            ],
            "_gte": [
                63
            ],
            "_in": [
                63
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                63
            ],
            "_lte": [
                63
            ],
            "_neq": [
                63
            ],
            "_nin": [
                63
            ],
            "__typename": [
                7
            ]
        },
        "env_variables": {
            "id": [
                596
            ],
            "key": [
                7
            ],
            "value": [
                7
            ],
            "value_type": [
                63
            ],
            "__typename": [
                7
            ]
        },
        "env_variables_bool_exp": {
            "_and": [
                66
            ],
            "_not": [
                66
            ],
            "_or": [
                66
            ],
            "id": [
                598
            ],
            "key": [
                8
            ],
            "value": [
                8
            ],
            "value_type": [
                64
            ],
            "__typename": [
                7
            ]
        },
        "env_variables_order_by": {
            "id": [
                164
            ],
            "key": [
                164
            ],
            "value": [
                164
            ],
            "value_type": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "env_variables_select_column": {},
        "env_variables_stream_cursor_input": {
            "initial_value": [
                70
            ],
            "ordering": [
                37
            ],
            "__typename": [
                7
            ]
        },
        "env_variables_stream_cursor_value_input": {
            "id": [
                596
            ],
            "key": [
                7
            ],
            "value": [
                7
            ],
            "value_type": [
                63
            ],
            "__typename": [
                7
            ]
        },
        "float8": {},
        "float8_comparison_exp": {
            "_eq": [
                71
            ],
            "_gt": [
                71
            ],
            "_gte": [
                71
            ],
            "_in": [
                71
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                71
            ],
            "_lte": [
                71
            ],
            "_neq": [
                71
            ],
            "_nin": [
                71
            ],
            "__typename": [
                7
            ]
        },
        "food_categories": {
            "Categories": [
                76,
                {
                    "distinct_on": [
                        86,
                        "[food_categories_products_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        85,
                        "[food_categories_products_order_by!]"
                    ],
                    "where": [
                        78
                    ]
                }
            ],
            "id": [
                596
            ],
            "name": [
                7
            ],
            "__typename": [
                7
            ]
        },
        "food_categories_bool_exp": {
            "Categories": [
                78
            ],
            "_and": [
                74
            ],
            "_not": [
                74
            ],
            "_or": [
                74
            ],
            "id": [
                598
            ],
            "name": [
                8
            ],
            "__typename": [
                7
            ]
        },
        "food_categories_order_by": {
            "Categories_aggregate": [
                77
            ],
            "id": [
                164
            ],
            "name": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "food_categories_products": {
            "Category": [
                73
            ],
            "Product": [
                172
            ],
            "food_categories_id": [
                596
            ],
            "id": [
                596
            ],
            "products_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "food_categories_products_aggregate_order_by": {
            "count": [
                164
            ],
            "max": [
                81
            ],
            "min": [
                82
            ],
            "__typename": [
                7
            ]
        },
        "food_categories_products_bool_exp": {
            "Category": [
                74
            ],
            "Product": [
                183
            ],
            "_and": [
                78
            ],
            "_not": [
                78
            ],
            "_or": [
                78
            ],
            "food_categories_id": [
                598
            ],
            "id": [
                598
            ],
            "products_id": [
                598
            ],
            "__typename": [
                7
            ]
        },
        "food_categories_products_constraint": {},
        "food_categories_products_insert_input": {
            "Product": [
                220
            ],
            "food_categories_id": [
                596
            ],
            "products_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "food_categories_products_max_order_by": {
            "food_categories_id": [
                164
            ],
            "id": [
                164
            ],
            "products_id": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "food_categories_products_min_order_by": {
            "food_categories_id": [
                164
            ],
            "id": [
                164
            ],
            "products_id": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "food_categories_products_mutation_response": {
            "affected_rows": [
                4
            ],
            "returning": [
                76
            ],
            "__typename": [
                7
            ]
        },
        "food_categories_products_on_conflict": {
            "constraint": [
                79
            ],
            "update_columns": [
                89
            ],
            "where": [
                78
            ],
            "__typename": [
                7
            ]
        },
        "food_categories_products_order_by": {
            "Category": [
                75
            ],
            "Product": [
                222
            ],
            "food_categories_id": [
                164
            ],
            "id": [
                164
            ],
            "products_id": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "food_categories_products_select_column": {},
        "food_categories_products_stream_cursor_input": {
            "initial_value": [
                88
            ],
            "ordering": [
                37
            ],
            "__typename": [
                7
            ]
        },
        "food_categories_products_stream_cursor_value_input": {
            "food_categories_id": [
                596
            ],
            "id": [
                596
            ],
            "products_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "food_categories_products_update_column": {},
        "food_categories_select_column": {},
        "food_categories_stream_cursor_input": {
            "initial_value": [
                92
            ],
            "ordering": [
                37
            ],
            "__typename": [
                7
            ]
        },
        "food_categories_stream_cursor_value_input": {
            "id": [
                596
            ],
            "name": [
                7
            ],
            "__typename": [
                7
            ]
        },
        "geography": {},
        "geography_cast_exp": {
            "geometry": [
                98
            ],
            "__typename": [
                7
            ]
        },
        "geography_comparison_exp": {
            "_cast": [
                94
            ],
            "_eq": [
                93
            ],
            "_gt": [
                93
            ],
            "_gte": [
                93
            ],
            "_in": [
                93
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                93
            ],
            "_lte": [
                93
            ],
            "_neq": [
                93
            ],
            "_nin": [
                93
            ],
            "_st_d_within": [
                572
            ],
            "_st_intersects": [
                93
            ],
            "__typename": [
                7
            ]
        },
        "geometry": {},
        "geometry_cast_exp": {
            "geography": [
                95
            ],
            "__typename": [
                7
            ]
        },
        "geometry_comparison_exp": {
            "_cast": [
                97
            ],
            "_eq": [
                96
            ],
            "_gt": [
                96
            ],
            "_gte": [
                96
            ],
            "_in": [
                96
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                96
            ],
            "_lte": [
                96
            ],
            "_neq": [
                96
            ],
            "_nin": [
                96
            ],
            "_st_3d_d_within": [
                573
            ],
            "_st_3d_intersects": [
                96
            ],
            "_st_contains": [
                96
            ],
            "_st_crosses": [
                96
            ],
            "_st_d_within": [
                573
            ],
            "_st_equals": [
                96
            ],
            "_st_intersects": [
                96
            ],
            "_st_overlaps": [
                96
            ],
            "_st_touches": [
                96
            ],
            "_st_within": [
                96
            ],
            "__typename": [
                7
            ]
        },
        "jsonb": {},
        "jsonb_cast_exp": {
            "String": [
                8
            ],
            "__typename": [
                7
            ]
        },
        "jsonb_comparison_exp": {
            "_cast": [
                100
            ],
            "_contained_in": [
                99
            ],
            "_contains": [
                99
            ],
            "_eq": [
                99
            ],
            "_gt": [
                99
            ],
            "_gte": [
                99
            ],
            "_has_key": [
                7
            ],
            "_has_keys_all": [
                7
            ],
            "_has_keys_any": [
                7
            ],
            "_in": [
                99
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                99
            ],
            "_lte": [
                99
            ],
            "_neq": [
                99
            ],
            "_nin": [
                99
            ],
            "__typename": [
                7
            ]
        },
        "messages": {
            "From": [
                110
            ],
            "Shipment": [
                441
            ],
            "To": [
                139
            ],
            "attachment": [
                99,
                {
                    "path": [
                        7
                    ]
                }
            ],
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "id": [
                596
            ],
            "location_stamp": [
                99,
                {
                    "path": [
                        7
                    ]
                }
            ],
            "read_timestamp": [
                578
            ],
            "shipment_id": [
                596
            ],
            "text": [
                7
            ],
            "__typename": [
                7
            ]
        },
        "messages_aggregate": {
            "aggregate": [
                106
            ],
            "nodes": [
                102
            ],
            "__typename": [
                7
            ]
        },
        "messages_aggregate_bool_exp": {
            "count": [
                105
            ],
            "__typename": [
                7
            ]
        },
        "messages_aggregate_bool_exp_count": {
            "arguments": [
                135
            ],
            "distinct": [
                0
            ],
            "filter": [
                108
            ],
            "predicate": [
                5
            ],
            "__typename": [
                7
            ]
        },
        "messages_aggregate_fields": {
            "count": [
                4,
                {
                    "columns": [
                        135,
                        "[messages_select_column!]"
                    ],
                    "distinct": [
                        0
                    ]
                }
            ],
            "max": [
                126
            ],
            "min": [
                128
            ],
            "__typename": [
                7
            ]
        },
        "messages_aggregate_order_by": {
            "count": [
                164
            ],
            "max": [
                127
            ],
            "min": [
                129
            ],
            "__typename": [
                7
            ]
        },
        "messages_bool_exp": {
            "From": [
                112
            ],
            "Shipment": [
                452
            ],
            "To": [
                141
            ],
            "_and": [
                108
            ],
            "_not": [
                108
            ],
            "_or": [
                108
            ],
            "attachment": [
                101
            ],
            "date_created": [
                579
            ],
            "date_updated": [
                579
            ],
            "id": [
                598
            ],
            "location_stamp": [
                101
            ],
            "read_timestamp": [
                579
            ],
            "shipment_id": [
                598
            ],
            "text": [
                8
            ],
            "__typename": [
                7
            ]
        },
        "messages_constraint": {},
        "messages_from": {
            "Buyer": [
                31
            ],
            "Driver": [
                40
            ],
            "Message": [
                102
            ],
            "Operator": [
                158
            ],
            "Seller": [
                306
            ],
            "Undefined_buyer": [
                582
            ],
            "buyer_id": [
                596
            ],
            "date_created": [
                576
            ],
            "date_updated": [
                578
            ],
            "driver_id": [
                596
            ],
            "id": [
                596
            ],
            "message_id": [
                596
            ],
            "operator_id": [
                596
            ],
            "seller_id": [
                596
            ],
            "undefined_buyer_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "messages_from_aggregate_order_by": {
            "count": [
                164
            ],
            "max": [
                115
            ],
            "min": [
                116
            ],
            "__typename": [
                7
            ]
        },
        "messages_from_bool_exp": {
            "Buyer": [
                32
            ],
            "Driver": [
                41
            ],
            "Message": [
                108
            ],
            "Operator": [
                159
            ],
            "Seller": [
                308
            ],
            "Undefined_buyer": [
                583
            ],
            "_and": [
                112
            ],
            "_not": [
                112
            ],
            "_or": [
                112
            ],
            "buyer_id": [
                598
            ],
            "date_created": [
                577
            ],
            "date_updated": [
                579
            ],
            "driver_id": [
                598
            ],
            "id": [
                598
            ],
            "message_id": [
                598
            ],
            "operator_id": [
                598
            ],
            "seller_id": [
                598
            ],
            "undefined_buyer_id": [
                598
            ],
            "__typename": [
                7
            ]
        },
        "messages_from_constraint": {},
        "messages_from_insert_input": {
            "Message": [
                131
            ],
            "Undefined_buyer": [
                587
            ],
            "message_id": [
                596
            ],
            "seller_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "messages_from_max_order_by": {
            "buyer_id": [
                164
            ],
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "driver_id": [
                164
            ],
            "id": [
                164
            ],
            "message_id": [
                164
            ],
            "operator_id": [
                164
            ],
            "seller_id": [
                164
            ],
            "undefined_buyer_id": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "messages_from_min_order_by": {
            "buyer_id": [
                164
            ],
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "driver_id": [
                164
            ],
            "id": [
                164
            ],
            "message_id": [
                164
            ],
            "operator_id": [
                164
            ],
            "seller_id": [
                164
            ],
            "undefined_buyer_id": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "messages_from_mutation_response": {
            "affected_rows": [
                4
            ],
            "returning": [
                110
            ],
            "__typename": [
                7
            ]
        },
        "messages_from_obj_rel_insert_input": {
            "data": [
                114
            ],
            "on_conflict": [
                119
            ],
            "__typename": [
                7
            ]
        },
        "messages_from_on_conflict": {
            "constraint": [
                113
            ],
            "update_columns": [
                124
            ],
            "where": [
                112
            ],
            "__typename": [
                7
            ]
        },
        "messages_from_order_by": {
            "Buyer": [
                33
            ],
            "Driver": [
                59
            ],
            "Message": [
                133
            ],
            "Operator": [
                160
            ],
            "Seller": [
                314
            ],
            "Undefined_buyer": [
                589
            ],
            "buyer_id": [
                164
            ],
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "driver_id": [
                164
            ],
            "id": [
                164
            ],
            "message_id": [
                164
            ],
            "operator_id": [
                164
            ],
            "seller_id": [
                164
            ],
            "undefined_buyer_id": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "messages_from_select_column": {},
        "messages_from_stream_cursor_input": {
            "initial_value": [
                123
            ],
            "ordering": [
                37
            ],
            "__typename": [
                7
            ]
        },
        "messages_from_stream_cursor_value_input": {
            "buyer_id": [
                596
            ],
            "date_created": [
                576
            ],
            "date_updated": [
                578
            ],
            "driver_id": [
                596
            ],
            "id": [
                596
            ],
            "message_id": [
                596
            ],
            "operator_id": [
                596
            ],
            "seller_id": [
                596
            ],
            "undefined_buyer_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "messages_from_update_column": {},
        "messages_insert_input": {
            "From": [
                118
            ],
            "To": [
                147
            ],
            "attachment": [
                99
            ],
            "location_stamp": [
                99
            ],
            "shipment_id": [
                596
            ],
            "text": [
                7
            ],
            "__typename": [
                7
            ]
        },
        "messages_max_fields": {
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "id": [
                596
            ],
            "read_timestamp": [
                578
            ],
            "shipment_id": [
                596
            ],
            "text": [
                7
            ],
            "__typename": [
                7
            ]
        },
        "messages_max_order_by": {
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "id": [
                164
            ],
            "read_timestamp": [
                164
            ],
            "shipment_id": [
                164
            ],
            "text": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "messages_min_fields": {
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "id": [
                596
            ],
            "read_timestamp": [
                578
            ],
            "shipment_id": [
                596
            ],
            "text": [
                7
            ],
            "__typename": [
                7
            ]
        },
        "messages_min_order_by": {
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "id": [
                164
            ],
            "read_timestamp": [
                164
            ],
            "shipment_id": [
                164
            ],
            "text": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "messages_mutation_response": {
            "affected_rows": [
                4
            ],
            "returning": [
                102
            ],
            "__typename": [
                7
            ]
        },
        "messages_obj_rel_insert_input": {
            "data": [
                125
            ],
            "on_conflict": [
                132
            ],
            "__typename": [
                7
            ]
        },
        "messages_on_conflict": {
            "constraint": [
                109
            ],
            "update_columns": [
                154
            ],
            "where": [
                108
            ],
            "__typename": [
                7
            ]
        },
        "messages_order_by": {
            "From": [
                120
            ],
            "Shipment": [
                497
            ],
            "To": [
                149
            ],
            "attachment": [
                164
            ],
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "id": [
                164
            ],
            "location_stamp": [
                164
            ],
            "read_timestamp": [
                164
            ],
            "shipment_id": [
                164
            ],
            "text": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "messages_pk_columns_input": {
            "id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "messages_select_column": {},
        "messages_set_input": {
            "read_timestamp": [
                578
            ],
            "__typename": [
                7
            ]
        },
        "messages_stream_cursor_input": {
            "initial_value": [
                138
            ],
            "ordering": [
                37
            ],
            "__typename": [
                7
            ]
        },
        "messages_stream_cursor_value_input": {
            "attachment": [
                99
            ],
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "id": [
                596
            ],
            "location_stamp": [
                99
            ],
            "read_timestamp": [
                578
            ],
            "shipment_id": [
                596
            ],
            "text": [
                7
            ],
            "__typename": [
                7
            ]
        },
        "messages_to": {
            "Buyer": [
                31
            ],
            "Driver": [
                40
            ],
            "Message": [
                102
            ],
            "Operator": [
                158
            ],
            "Seller": [
                306
            ],
            "Undefined_buyer": [
                582
            ],
            "buyer_id": [
                596
            ],
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "driver_id": [
                596
            ],
            "id": [
                596
            ],
            "message_id": [
                596
            ],
            "operator_id": [
                596
            ],
            "seller_id": [
                596
            ],
            "undefined_buyer_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "messages_to_aggregate_order_by": {
            "count": [
                164
            ],
            "max": [
                144
            ],
            "min": [
                145
            ],
            "__typename": [
                7
            ]
        },
        "messages_to_bool_exp": {
            "Buyer": [
                32
            ],
            "Driver": [
                41
            ],
            "Message": [
                108
            ],
            "Operator": [
                159
            ],
            "Seller": [
                308
            ],
            "Undefined_buyer": [
                583
            ],
            "_and": [
                141
            ],
            "_not": [
                141
            ],
            "_or": [
                141
            ],
            "buyer_id": [
                598
            ],
            "date_created": [
                579
            ],
            "date_updated": [
                579
            ],
            "driver_id": [
                598
            ],
            "id": [
                598
            ],
            "message_id": [
                598
            ],
            "operator_id": [
                598
            ],
            "seller_id": [
                598
            ],
            "undefined_buyer_id": [
                598
            ],
            "__typename": [
                7
            ]
        },
        "messages_to_constraint": {},
        "messages_to_insert_input": {
            "Message": [
                131
            ],
            "Undefined_buyer": [
                587
            ],
            "buyer_id": [
                596
            ],
            "driver_id": [
                596
            ],
            "message_id": [
                596
            ],
            "operator_id": [
                596
            ],
            "undefined_buyer_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "messages_to_max_order_by": {
            "buyer_id": [
                164
            ],
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "driver_id": [
                164
            ],
            "id": [
                164
            ],
            "message_id": [
                164
            ],
            "operator_id": [
                164
            ],
            "seller_id": [
                164
            ],
            "undefined_buyer_id": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "messages_to_min_order_by": {
            "buyer_id": [
                164
            ],
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "driver_id": [
                164
            ],
            "id": [
                164
            ],
            "message_id": [
                164
            ],
            "operator_id": [
                164
            ],
            "seller_id": [
                164
            ],
            "undefined_buyer_id": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "messages_to_mutation_response": {
            "affected_rows": [
                4
            ],
            "returning": [
                139
            ],
            "__typename": [
                7
            ]
        },
        "messages_to_obj_rel_insert_input": {
            "data": [
                143
            ],
            "on_conflict": [
                148
            ],
            "__typename": [
                7
            ]
        },
        "messages_to_on_conflict": {
            "constraint": [
                142
            ],
            "update_columns": [
                153
            ],
            "where": [
                141
            ],
            "__typename": [
                7
            ]
        },
        "messages_to_order_by": {
            "Buyer": [
                33
            ],
            "Driver": [
                59
            ],
            "Message": [
                133
            ],
            "Operator": [
                160
            ],
            "Seller": [
                314
            ],
            "Undefined_buyer": [
                589
            ],
            "buyer_id": [
                164
            ],
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "driver_id": [
                164
            ],
            "id": [
                164
            ],
            "message_id": [
                164
            ],
            "operator_id": [
                164
            ],
            "seller_id": [
                164
            ],
            "undefined_buyer_id": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "messages_to_select_column": {},
        "messages_to_stream_cursor_input": {
            "initial_value": [
                152
            ],
            "ordering": [
                37
            ],
            "__typename": [
                7
            ]
        },
        "messages_to_stream_cursor_value_input": {
            "buyer_id": [
                596
            ],
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "driver_id": [
                596
            ],
            "id": [
                596
            ],
            "message_id": [
                596
            ],
            "operator_id": [
                596
            ],
            "seller_id": [
                596
            ],
            "undefined_buyer_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "messages_to_update_column": {},
        "messages_update_column": {},
        "messages_updates": {
            "_set": [
                136
            ],
            "where": [
                108
            ],
            "__typename": [
                7
            ]
        },
        "numeric": {},
        "numeric_comparison_exp": {
            "_eq": [
                156
            ],
            "_gt": [
                156
            ],
            "_gte": [
                156
            ],
            "_in": [
                156
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                156
            ],
            "_lte": [
                156
            ],
            "_neq": [
                156
            ],
            "_nin": [
                156
            ],
            "__typename": [
                7
            ]
        },
        "operators": {
            "Messages_incoming": [
                139,
                {
                    "distinct_on": [
                        150,
                        "[messages_to_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        149,
                        "[messages_to_order_by!]"
                    ],
                    "where": [
                        141
                    ]
                }
            ],
            "Messages_outgoing": [
                110,
                {
                    "distinct_on": [
                        121,
                        "[messages_from_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        120,
                        "[messages_from_order_by!]"
                    ],
                    "where": [
                        112
                    ]
                }
            ],
            "id": [
                596
            ],
            "image_id": [
                596
            ],
            "name": [
                7
            ],
            "__typename": [
                7
            ]
        },
        "operators_bool_exp": {
            "Messages_incoming": [
                141
            ],
            "Messages_outgoing": [
                112
            ],
            "_and": [
                159
            ],
            "_not": [
                159
            ],
            "_or": [
                159
            ],
            "id": [
                598
            ],
            "image_id": [
                598
            ],
            "name": [
                8
            ],
            "__typename": [
                7
            ]
        },
        "operators_order_by": {
            "Messages_incoming_aggregate": [
                140
            ],
            "Messages_outgoing_aggregate": [
                111
            ],
            "id": [
                164
            ],
            "image_id": [
                164
            ],
            "name": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "operators_select_column": {},
        "operators_stream_cursor_input": {
            "initial_value": [
                163
            ],
            "ordering": [
                37
            ],
            "__typename": [
                7
            ]
        },
        "operators_stream_cursor_value_input": {
            "id": [
                596
            ],
            "image_id": [
                596
            ],
            "name": [
                7
            ],
            "__typename": [
                7
            ]
        },
        "order_by": {},
        "payment_gateway": {},
        "payment_gateway_comparison_exp": {
            "_eq": [
                165
            ],
            "_gt": [
                165
            ],
            "_gte": [
                165
            ],
            "_in": [
                165
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                165
            ],
            "_lte": [
                165
            ],
            "_neq": [
                165
            ],
            "_nin": [
                165
            ],
            "__typename": [
                7
            ]
        },
        "payment_method": {},
        "payment_method_array_comparison_exp": {
            "_contained_in": [
                167
            ],
            "_contains": [
                167
            ],
            "_eq": [
                167
            ],
            "_gt": [
                167
            ],
            "_gte": [
                167
            ],
            "_in": [
                167
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                167
            ],
            "_lte": [
                167
            ],
            "_neq": [
                167
            ],
            "_nin": [
                167
            ],
            "__typename": [
                7
            ]
        },
        "payment_method_comparison_exp": {
            "_eq": [
                167
            ],
            "_gt": [
                167
            ],
            "_gte": [
                167
            ],
            "_in": [
                167
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                167
            ],
            "_lte": [
                167
            ],
            "_neq": [
                167
            ],
            "_nin": [
                167
            ],
            "__typename": [
                7
            ]
        },
        "payment_status": {},
        "payment_status_comparison_exp": {
            "_eq": [
                170
            ],
            "_gt": [
                170
            ],
            "_gte": [
                170
            ],
            "_in": [
                170
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                170
            ],
            "_lte": [
                170
            ],
            "_neq": [
                170
            ],
            "_nin": [
                170
            ],
            "__typename": [
                7
            ]
        },
        "products": {
            "Extras": [
                185,
                {
                    "distinct_on": [
                        200,
                        "[products_extras_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        198,
                        "[products_extras_order_by!]"
                    ],
                    "where": [
                        189
                    ]
                }
            ],
            "Seller": [
                306
            ],
            "Shipments": [
                397,
                {
                    "distinct_on": [
                        419,
                        "[shipment_products_items_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        417,
                        "[shipment_products_items_order_by!]"
                    ],
                    "where": [
                        406
                    ]
                }
            ],
            "Shipments_aggregate": [
                398,
                {
                    "distinct_on": [
                        419,
                        "[shipment_products_items_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        417,
                        "[shipment_products_items_order_by!]"
                    ],
                    "where": [
                        406
                    ]
                }
            ],
            "Standard_size": [
                248
            ],
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "description": [
                7
            ],
            "dimensions_cm": [
                38
            ],
            "extra_images_ids": [
                596
            ],
            "id": [
                596
            ],
            "image_id": [
                596
            ],
            "is_available": [
                0
            ],
            "is_deleted": [
                0
            ],
            "is_public": [
                0
            ],
            "is_retail": [
                0
            ],
            "min_quantity": [
                156
            ],
            "name": [
                7
            ],
            "price": [
                156
            ],
            "seller_id": [
                596
            ],
            "standard_size_id": [
                596
            ],
            "volume_cm3": [
                156
            ],
            "__typename": [
                7
            ]
        },
        "products_aggregate": {
            "aggregate": [
                178
            ],
            "nodes": [
                172
            ],
            "__typename": [
                7
            ]
        },
        "products_aggregate_bool_exp": {
            "bool_and": [
                175
            ],
            "bool_or": [
                176
            ],
            "count": [
                177
            ],
            "__typename": [
                7
            ]
        },
        "products_aggregate_bool_exp_bool_and": {
            "arguments": [
                225
            ],
            "distinct": [
                0
            ],
            "filter": [
                183
            ],
            "predicate": [
                1
            ],
            "__typename": [
                7
            ]
        },
        "products_aggregate_bool_exp_bool_or": {
            "arguments": [
                226
            ],
            "distinct": [
                0
            ],
            "filter": [
                183
            ],
            "predicate": [
                1
            ],
            "__typename": [
                7
            ]
        },
        "products_aggregate_bool_exp_count": {
            "arguments": [
                224
            ],
            "distinct": [
                0
            ],
            "filter": [
                183
            ],
            "predicate": [
                5
            ],
            "__typename": [
                7
            ]
        },
        "products_aggregate_fields": {
            "avg": [
                181
            ],
            "count": [
                4,
                {
                    "columns": [
                        224,
                        "[products_select_column!]"
                    ],
                    "distinct": [
                        0
                    ]
                }
            ],
            "max": [
                215
            ],
            "min": [
                217
            ],
            "stddev": [
                228
            ],
            "stddev_pop": [
                230
            ],
            "stddev_samp": [
                232
            ],
            "sum": [
                236
            ],
            "var_pop": [
                240
            ],
            "var_samp": [
                242
            ],
            "variance": [
                244
            ],
            "__typename": [
                7
            ]
        },
        "products_aggregate_order_by": {
            "avg": [
                182
            ],
            "count": [
                164
            ],
            "max": [
                216
            ],
            "min": [
                218
            ],
            "stddev": [
                229
            ],
            "stddev_pop": [
                231
            ],
            "stddev_samp": [
                233
            ],
            "sum": [
                237
            ],
            "var_pop": [
                241
            ],
            "var_samp": [
                243
            ],
            "variance": [
                245
            ],
            "__typename": [
                7
            ]
        },
        "products_arr_rel_insert_input": {
            "data": [
                214
            ],
            "on_conflict": [
                221
            ],
            "__typename": [
                7
            ]
        },
        "products_avg_fields": {
            "min_quantity": [
                2
            ],
            "price": [
                2
            ],
            "volume_cm3": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "products_avg_order_by": {
            "min_quantity": [
                164
            ],
            "price": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "products_bool_exp": {
            "Extras": [
                189
            ],
            "Seller": [
                308
            ],
            "Shipments": [
                406
            ],
            "Shipments_aggregate": [
                399
            ],
            "Standard_size": [
                251
            ],
            "_and": [
                183
            ],
            "_not": [
                183
            ],
            "_or": [
                183
            ],
            "date_created": [
                579
            ],
            "date_updated": [
                579
            ],
            "description": [
                8
            ],
            "dimensions_cm": [
                39
            ],
            "extra_images_ids": [
                597
            ],
            "id": [
                598
            ],
            "image_id": [
                598
            ],
            "is_available": [
                1
            ],
            "is_deleted": [
                1
            ],
            "is_public": [
                1
            ],
            "is_retail": [
                1
            ],
            "min_quantity": [
                157
            ],
            "name": [
                8
            ],
            "price": [
                157
            ],
            "seller_id": [
                598
            ],
            "standard_size_id": [
                598
            ],
            "volume_cm3": [
                157
            ],
            "__typename": [
                7
            ]
        },
        "products_constraint": {},
        "products_extras": {
            "Product": [
                172
            ],
            "Shipment_products": [
                370,
                {
                    "distinct_on": [
                        384,
                        "[shipment_product_item_extras_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        382,
                        "[shipment_product_item_extras_order_by!]"
                    ],
                    "where": [
                        374
                    ]
                }
            ],
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "description": [
                7
            ],
            "id": [
                596
            ],
            "is_available": [
                0
            ],
            "name": [
                7
            ],
            "price": [
                156
            ],
            "product_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "products_extras_aggregate_order_by": {
            "avg": [
                188
            ],
            "count": [
                164
            ],
            "max": [
                193
            ],
            "min": [
                194
            ],
            "stddev": [
                202
            ],
            "stddev_pop": [
                203
            ],
            "stddev_samp": [
                204
            ],
            "sum": [
                207
            ],
            "var_pop": [
                210
            ],
            "var_samp": [
                211
            ],
            "variance": [
                212
            ],
            "__typename": [
                7
            ]
        },
        "products_extras_arr_rel_insert_input": {
            "data": [
                192
            ],
            "on_conflict": [
                197
            ],
            "__typename": [
                7
            ]
        },
        "products_extras_avg_order_by": {
            "price": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "products_extras_bool_exp": {
            "Product": [
                183
            ],
            "Shipment_products": [
                374
            ],
            "_and": [
                189
            ],
            "_not": [
                189
            ],
            "_or": [
                189
            ],
            "date_created": [
                579
            ],
            "date_updated": [
                579
            ],
            "description": [
                8
            ],
            "id": [
                598
            ],
            "is_available": [
                1
            ],
            "name": [
                8
            ],
            "price": [
                157
            ],
            "product_id": [
                598
            ],
            "__typename": [
                7
            ]
        },
        "products_extras_constraint": {},
        "products_extras_inc_input": {
            "price": [
                156
            ],
            "__typename": [
                7
            ]
        },
        "products_extras_insert_input": {
            "Product": [
                220
            ],
            "Shipment_products": [
                372
            ],
            "description": [
                7
            ],
            "name": [
                7
            ],
            "price": [
                156
            ],
            "product_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "products_extras_max_order_by": {
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "description": [
                164
            ],
            "id": [
                164
            ],
            "name": [
                164
            ],
            "price": [
                164
            ],
            "product_id": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "products_extras_min_order_by": {
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "description": [
                164
            ],
            "id": [
                164
            ],
            "name": [
                164
            ],
            "price": [
                164
            ],
            "product_id": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "products_extras_mutation_response": {
            "affected_rows": [
                4
            ],
            "returning": [
                185
            ],
            "__typename": [
                7
            ]
        },
        "products_extras_obj_rel_insert_input": {
            "data": [
                192
            ],
            "on_conflict": [
                197
            ],
            "__typename": [
                7
            ]
        },
        "products_extras_on_conflict": {
            "constraint": [
                190
            ],
            "update_columns": [
                208
            ],
            "where": [
                189
            ],
            "__typename": [
                7
            ]
        },
        "products_extras_order_by": {
            "Product": [
                222
            ],
            "Shipment_products_aggregate": [
                371
            ],
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "description": [
                164
            ],
            "id": [
                164
            ],
            "is_available": [
                164
            ],
            "name": [
                164
            ],
            "price": [
                164
            ],
            "product_id": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "products_extras_pk_columns_input": {
            "id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "products_extras_select_column": {},
        "products_extras_set_input": {
            "date_updated": [
                578
            ],
            "description": [
                7
            ],
            "is_available": [
                0
            ],
            "is_deleted": [
                0
            ],
            "name": [
                7
            ],
            "price": [
                156
            ],
            "__typename": [
                7
            ]
        },
        "products_extras_stddev_order_by": {
            "price": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "products_extras_stddev_pop_order_by": {
            "price": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "products_extras_stddev_samp_order_by": {
            "price": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "products_extras_stream_cursor_input": {
            "initial_value": [
                206
            ],
            "ordering": [
                37
            ],
            "__typename": [
                7
            ]
        },
        "products_extras_stream_cursor_value_input": {
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "description": [
                7
            ],
            "id": [
                596
            ],
            "is_available": [
                0
            ],
            "name": [
                7
            ],
            "price": [
                156
            ],
            "product_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "products_extras_sum_order_by": {
            "price": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "products_extras_update_column": {},
        "products_extras_updates": {
            "_inc": [
                191
            ],
            "_set": [
                201
            ],
            "where": [
                189
            ],
            "__typename": [
                7
            ]
        },
        "products_extras_var_pop_order_by": {
            "price": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "products_extras_var_samp_order_by": {
            "price": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "products_extras_variance_order_by": {
            "price": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "products_inc_input": {
            "min_quantity": [
                156
            ],
            "price": [
                156
            ],
            "__typename": [
                7
            ]
        },
        "products_insert_input": {
            "Extras": [
                187
            ],
            "Shipments": [
                403
            ],
            "Standard_size": [
                257
            ],
            "description": [
                7
            ],
            "dimensions_cm": [
                38
            ],
            "image_id": [
                596
            ],
            "is_available": [
                0
            ],
            "min_quantity": [
                156
            ],
            "name": [
                7
            ],
            "price": [
                156
            ],
            "seller_id": [
                596
            ],
            "standard_size_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "products_max_fields": {
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "description": [
                7
            ],
            "dimensions_cm": [
                38
            ],
            "extra_images_ids": [
                596
            ],
            "id": [
                596
            ],
            "image_id": [
                596
            ],
            "min_quantity": [
                156
            ],
            "name": [
                7
            ],
            "price": [
                156
            ],
            "seller_id": [
                596
            ],
            "standard_size_id": [
                596
            ],
            "volume_cm3": [
                156
            ],
            "__typename": [
                7
            ]
        },
        "products_max_order_by": {
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "description": [
                164
            ],
            "dimensions_cm": [
                164
            ],
            "extra_images_ids": [
                164
            ],
            "id": [
                164
            ],
            "image_id": [
                164
            ],
            "min_quantity": [
                164
            ],
            "name": [
                164
            ],
            "price": [
                164
            ],
            "seller_id": [
                164
            ],
            "standard_size_id": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "products_min_fields": {
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "description": [
                7
            ],
            "dimensions_cm": [
                38
            ],
            "extra_images_ids": [
                596
            ],
            "id": [
                596
            ],
            "image_id": [
                596
            ],
            "min_quantity": [
                156
            ],
            "name": [
                7
            ],
            "price": [
                156
            ],
            "seller_id": [
                596
            ],
            "standard_size_id": [
                596
            ],
            "volume_cm3": [
                156
            ],
            "__typename": [
                7
            ]
        },
        "products_min_order_by": {
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "description": [
                164
            ],
            "dimensions_cm": [
                164
            ],
            "extra_images_ids": [
                164
            ],
            "id": [
                164
            ],
            "image_id": [
                164
            ],
            "min_quantity": [
                164
            ],
            "name": [
                164
            ],
            "price": [
                164
            ],
            "seller_id": [
                164
            ],
            "standard_size_id": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "products_mutation_response": {
            "affected_rows": [
                4
            ],
            "returning": [
                172
            ],
            "__typename": [
                7
            ]
        },
        "products_obj_rel_insert_input": {
            "data": [
                214
            ],
            "on_conflict": [
                221
            ],
            "__typename": [
                7
            ]
        },
        "products_on_conflict": {
            "constraint": [
                184
            ],
            "update_columns": [
                238
            ],
            "where": [
                183
            ],
            "__typename": [
                7
            ]
        },
        "products_order_by": {
            "Extras_aggregate": [
                186
            ],
            "Seller": [
                314
            ],
            "Shipments_aggregate": [
                402
            ],
            "Standard_size": [
                259
            ],
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "description": [
                164
            ],
            "dimensions_cm": [
                164
            ],
            "extra_images_ids": [
                164
            ],
            "id": [
                164
            ],
            "image_id": [
                164
            ],
            "is_available": [
                164
            ],
            "is_deleted": [
                164
            ],
            "is_public": [
                164
            ],
            "is_retail": [
                164
            ],
            "min_quantity": [
                164
            ],
            "name": [
                164
            ],
            "price": [
                164
            ],
            "seller_id": [
                164
            ],
            "standard_size_id": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "products_pk_columns_input": {
            "id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "products_select_column": {},
        "products_select_column_products_aggregate_bool_exp_bool_and_arguments_columns": {},
        "products_select_column_products_aggregate_bool_exp_bool_or_arguments_columns": {},
        "products_set_input": {
            "date_updated": [
                578
            ],
            "description": [
                7
            ],
            "dimensions_cm": [
                38
            ],
            "extra_images_ids": [
                596
            ],
            "image_id": [
                596
            ],
            "is_available": [
                0
            ],
            "is_deleted": [
                0
            ],
            "is_public": [
                0
            ],
            "min_quantity": [
                156
            ],
            "name": [
                7
            ],
            "price": [
                156
            ],
            "standard_size_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "products_stddev_fields": {
            "min_quantity": [
                2
            ],
            "price": [
                2
            ],
            "volume_cm3": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "products_stddev_order_by": {
            "min_quantity": [
                164
            ],
            "price": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "products_stddev_pop_fields": {
            "min_quantity": [
                2
            ],
            "price": [
                2
            ],
            "volume_cm3": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "products_stddev_pop_order_by": {
            "min_quantity": [
                164
            ],
            "price": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "products_stddev_samp_fields": {
            "min_quantity": [
                2
            ],
            "price": [
                2
            ],
            "volume_cm3": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "products_stddev_samp_order_by": {
            "min_quantity": [
                164
            ],
            "price": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "products_stream_cursor_input": {
            "initial_value": [
                235
            ],
            "ordering": [
                37
            ],
            "__typename": [
                7
            ]
        },
        "products_stream_cursor_value_input": {
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "description": [
                7
            ],
            "dimensions_cm": [
                38
            ],
            "extra_images_ids": [
                596
            ],
            "id": [
                596
            ],
            "image_id": [
                596
            ],
            "is_available": [
                0
            ],
            "is_deleted": [
                0
            ],
            "is_public": [
                0
            ],
            "is_retail": [
                0
            ],
            "min_quantity": [
                156
            ],
            "name": [
                7
            ],
            "price": [
                156
            ],
            "seller_id": [
                596
            ],
            "standard_size_id": [
                596
            ],
            "volume_cm3": [
                156
            ],
            "__typename": [
                7
            ]
        },
        "products_sum_fields": {
            "min_quantity": [
                156
            ],
            "price": [
                156
            ],
            "volume_cm3": [
                156
            ],
            "__typename": [
                7
            ]
        },
        "products_sum_order_by": {
            "min_quantity": [
                164
            ],
            "price": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "products_update_column": {},
        "products_updates": {
            "_inc": [
                213
            ],
            "_set": [
                227
            ],
            "where": [
                183
            ],
            "__typename": [
                7
            ]
        },
        "products_var_pop_fields": {
            "min_quantity": [
                2
            ],
            "price": [
                2
            ],
            "volume_cm3": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "products_var_pop_order_by": {
            "min_quantity": [
                164
            ],
            "price": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "products_var_samp_fields": {
            "min_quantity": [
                2
            ],
            "price": [
                2
            ],
            "volume_cm3": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "products_var_samp_order_by": {
            "min_quantity": [
                164
            ],
            "price": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "products_variance_fields": {
            "min_quantity": [
                2
            ],
            "price": [
                2
            ],
            "volume_cm3": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "products_variance_order_by": {
            "min_quantity": [
                164
            ],
            "price": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "route_step_status": {},
        "route_step_status_comparison_exp": {
            "_eq": [
                246
            ],
            "_gt": [
                246
            ],
            "_gte": [
                246
            ],
            "_in": [
                246
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                246
            ],
            "_lte": [
                246
            ],
            "_neq": [
                246
            ],
            "_nin": [
                246
            ],
            "__typename": [
                7
            ]
        },
        "seller_products_standard_sizes": {
            "Products": [
                172,
                {
                    "distinct_on": [
                        224,
                        "[products_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        222,
                        "[products_order_by!]"
                    ],
                    "where": [
                        183
                    ]
                }
            ],
            "Products_aggregate": [
                173,
                {
                    "distinct_on": [
                        224,
                        "[products_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        222,
                        "[products_order_by!]"
                    ],
                    "where": [
                        183
                    ]
                }
            ],
            "Seller": [
                306
            ],
            "date_created": [
                578
            ],
            "date_deleted": [
                578
            ],
            "date_updated": [
                578
            ],
            "height": [
                156
            ],
            "id": [
                596
            ],
            "length": [
                156
            ],
            "name": [
                7
            ],
            "seller_id": [
                596
            ],
            "volume_cm3": [
                156
            ],
            "width": [
                156
            ],
            "__typename": [
                7
            ]
        },
        "seller_products_standard_sizes_aggregate_order_by": {
            "avg": [
                250
            ],
            "count": [
                164
            ],
            "max": [
                254
            ],
            "min": [
                255
            ],
            "stddev": [
                261
            ],
            "stddev_pop": [
                262
            ],
            "stddev_samp": [
                263
            ],
            "sum": [
                266
            ],
            "var_pop": [
                268
            ],
            "var_samp": [
                269
            ],
            "variance": [
                270
            ],
            "__typename": [
                7
            ]
        },
        "seller_products_standard_sizes_avg_order_by": {
            "height": [
                164
            ],
            "length": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "width": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "seller_products_standard_sizes_bool_exp": {
            "Products": [
                183
            ],
            "Products_aggregate": [
                174
            ],
            "Seller": [
                308
            ],
            "_and": [
                251
            ],
            "_not": [
                251
            ],
            "_or": [
                251
            ],
            "date_created": [
                579
            ],
            "date_deleted": [
                579
            ],
            "date_updated": [
                579
            ],
            "height": [
                157
            ],
            "id": [
                598
            ],
            "length": [
                157
            ],
            "name": [
                8
            ],
            "seller_id": [
                598
            ],
            "volume_cm3": [
                157
            ],
            "width": [
                157
            ],
            "__typename": [
                7
            ]
        },
        "seller_products_standard_sizes_constraint": {},
        "seller_products_standard_sizes_insert_input": {
            "Products": [
                180
            ],
            "height": [
                156
            ],
            "length": [
                156
            ],
            "name": [
                7
            ],
            "seller_id": [
                596
            ],
            "width": [
                156
            ],
            "__typename": [
                7
            ]
        },
        "seller_products_standard_sizes_max_order_by": {
            "date_created": [
                164
            ],
            "date_deleted": [
                164
            ],
            "date_updated": [
                164
            ],
            "height": [
                164
            ],
            "id": [
                164
            ],
            "length": [
                164
            ],
            "name": [
                164
            ],
            "seller_id": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "width": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "seller_products_standard_sizes_min_order_by": {
            "date_created": [
                164
            ],
            "date_deleted": [
                164
            ],
            "date_updated": [
                164
            ],
            "height": [
                164
            ],
            "id": [
                164
            ],
            "length": [
                164
            ],
            "name": [
                164
            ],
            "seller_id": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "width": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "seller_products_standard_sizes_mutation_response": {
            "affected_rows": [
                4
            ],
            "returning": [
                248
            ],
            "__typename": [
                7
            ]
        },
        "seller_products_standard_sizes_obj_rel_insert_input": {
            "data": [
                253
            ],
            "on_conflict": [
                258
            ],
            "__typename": [
                7
            ]
        },
        "seller_products_standard_sizes_on_conflict": {
            "constraint": [
                252
            ],
            "update_columns": [
                267
            ],
            "where": [
                251
            ],
            "__typename": [
                7
            ]
        },
        "seller_products_standard_sizes_order_by": {
            "Products_aggregate": [
                179
            ],
            "Seller": [
                314
            ],
            "date_created": [
                164
            ],
            "date_deleted": [
                164
            ],
            "date_updated": [
                164
            ],
            "height": [
                164
            ],
            "id": [
                164
            ],
            "length": [
                164
            ],
            "name": [
                164
            ],
            "seller_id": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "width": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "seller_products_standard_sizes_select_column": {},
        "seller_products_standard_sizes_stddev_order_by": {
            "height": [
                164
            ],
            "length": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "width": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "seller_products_standard_sizes_stddev_pop_order_by": {
            "height": [
                164
            ],
            "length": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "width": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "seller_products_standard_sizes_stddev_samp_order_by": {
            "height": [
                164
            ],
            "length": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "width": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "seller_products_standard_sizes_stream_cursor_input": {
            "initial_value": [
                265
            ],
            "ordering": [
                37
            ],
            "__typename": [
                7
            ]
        },
        "seller_products_standard_sizes_stream_cursor_value_input": {
            "date_created": [
                578
            ],
            "date_deleted": [
                578
            ],
            "date_updated": [
                578
            ],
            "height": [
                156
            ],
            "id": [
                596
            ],
            "length": [
                156
            ],
            "name": [
                7
            ],
            "seller_id": [
                596
            ],
            "volume_cm3": [
                156
            ],
            "width": [
                156
            ],
            "__typename": [
                7
            ]
        },
        "seller_products_standard_sizes_sum_order_by": {
            "height": [
                164
            ],
            "length": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "width": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "seller_products_standard_sizes_update_column": {},
        "seller_products_standard_sizes_var_pop_order_by": {
            "height": [
                164
            ],
            "length": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "width": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "seller_products_standard_sizes_var_samp_order_by": {
            "height": [
                164
            ],
            "length": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "width": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "seller_products_standard_sizes_variance_order_by": {
            "height": [
                164
            ],
            "length": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "width": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews": {
            "Buyer": [
                31
            ],
            "Seller": [
                306
            ],
            "Shipment": [
                441
            ],
            "Undefined_buyer": [
                582
            ],
            "body": [
                7
            ],
            "buyer_id": [
                596
            ],
            "date_created": [
                578
            ],
            "id": [
                596
            ],
            "rating": [
                4
            ],
            "seller_id": [
                596
            ],
            "seller_reply": [
                7
            ],
            "seller_reply_at": [
                578
            ],
            "shipment_id": [
                596
            ],
            "undefined_buyer_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_aggregate": {
            "aggregate": [
                275
            ],
            "nodes": [
                271
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_aggregate_bool_exp": {
            "count": [
                274
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_aggregate_bool_exp_count": {
            "arguments": [
                287
            ],
            "distinct": [
                0
            ],
            "filter": [
                279
            ],
            "predicate": [
                5
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_aggregate_fields": {
            "avg": [
                277
            ],
            "count": [
                4,
                {
                    "columns": [
                        287,
                        "[seller_reviews_select_column!]"
                    ],
                    "distinct": [
                        0
                    ]
                }
            ],
            "max": [
                280
            ],
            "min": [
                282
            ],
            "stddev": [
                289
            ],
            "stddev_pop": [
                291
            ],
            "stddev_samp": [
                293
            ],
            "sum": [
                297
            ],
            "var_pop": [
                300
            ],
            "var_samp": [
                302
            ],
            "variance": [
                304
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_aggregate_order_by": {
            "avg": [
                278
            ],
            "count": [
                164
            ],
            "max": [
                281
            ],
            "min": [
                283
            ],
            "stddev": [
                290
            ],
            "stddev_pop": [
                292
            ],
            "stddev_samp": [
                294
            ],
            "sum": [
                298
            ],
            "var_pop": [
                301
            ],
            "var_samp": [
                303
            ],
            "variance": [
                305
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_avg_fields": {
            "rating": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_avg_order_by": {
            "rating": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_bool_exp": {
            "Buyer": [
                32
            ],
            "Seller": [
                308
            ],
            "Shipment": [
                452
            ],
            "Undefined_buyer": [
                583
            ],
            "_and": [
                279
            ],
            "_not": [
                279
            ],
            "_or": [
                279
            ],
            "body": [
                8
            ],
            "buyer_id": [
                598
            ],
            "date_created": [
                579
            ],
            "id": [
                598
            ],
            "rating": [
                5
            ],
            "seller_id": [
                598
            ],
            "seller_reply": [
                8
            ],
            "seller_reply_at": [
                579
            ],
            "shipment_id": [
                598
            ],
            "undefined_buyer_id": [
                598
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_max_fields": {
            "body": [
                7
            ],
            "buyer_id": [
                596
            ],
            "date_created": [
                578
            ],
            "id": [
                596
            ],
            "rating": [
                4
            ],
            "seller_id": [
                596
            ],
            "seller_reply": [
                7
            ],
            "seller_reply_at": [
                578
            ],
            "shipment_id": [
                596
            ],
            "undefined_buyer_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_max_order_by": {
            "body": [
                164
            ],
            "buyer_id": [
                164
            ],
            "date_created": [
                164
            ],
            "id": [
                164
            ],
            "rating": [
                164
            ],
            "seller_id": [
                164
            ],
            "seller_reply": [
                164
            ],
            "seller_reply_at": [
                164
            ],
            "shipment_id": [
                164
            ],
            "undefined_buyer_id": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_min_fields": {
            "body": [
                7
            ],
            "buyer_id": [
                596
            ],
            "date_created": [
                578
            ],
            "id": [
                596
            ],
            "rating": [
                4
            ],
            "seller_id": [
                596
            ],
            "seller_reply": [
                7
            ],
            "seller_reply_at": [
                578
            ],
            "shipment_id": [
                596
            ],
            "undefined_buyer_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_min_order_by": {
            "body": [
                164
            ],
            "buyer_id": [
                164
            ],
            "date_created": [
                164
            ],
            "id": [
                164
            ],
            "rating": [
                164
            ],
            "seller_id": [
                164
            ],
            "seller_reply": [
                164
            ],
            "seller_reply_at": [
                164
            ],
            "shipment_id": [
                164
            ],
            "undefined_buyer_id": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_mutation_response": {
            "affected_rows": [
                4
            ],
            "returning": [
                271
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_order_by": {
            "Buyer": [
                33
            ],
            "Seller": [
                314
            ],
            "Shipment": [
                497
            ],
            "Undefined_buyer": [
                589
            ],
            "body": [
                164
            ],
            "buyer_id": [
                164
            ],
            "date_created": [
                164
            ],
            "id": [
                164
            ],
            "rating": [
                164
            ],
            "seller_id": [
                164
            ],
            "seller_reply": [
                164
            ],
            "seller_reply_at": [
                164
            ],
            "shipment_id": [
                164
            ],
            "undefined_buyer_id": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_pk_columns_input": {
            "id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_select_column": {},
        "seller_reviews_set_input": {
            "seller_reply": [
                7
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_stddev_fields": {
            "rating": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_stddev_order_by": {
            "rating": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_stddev_pop_fields": {
            "rating": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_stddev_pop_order_by": {
            "rating": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_stddev_samp_fields": {
            "rating": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_stddev_samp_order_by": {
            "rating": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_stream_cursor_input": {
            "initial_value": [
                296
            ],
            "ordering": [
                37
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_stream_cursor_value_input": {
            "body": [
                7
            ],
            "buyer_id": [
                596
            ],
            "date_created": [
                578
            ],
            "id": [
                596
            ],
            "rating": [
                4
            ],
            "seller_id": [
                596
            ],
            "seller_reply": [
                7
            ],
            "seller_reply_at": [
                578
            ],
            "shipment_id": [
                596
            ],
            "undefined_buyer_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_sum_fields": {
            "rating": [
                4
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_sum_order_by": {
            "rating": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_updates": {
            "_set": [
                288
            ],
            "where": [
                279
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_var_pop_fields": {
            "rating": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_var_pop_order_by": {
            "rating": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_var_samp_fields": {
            "rating": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_var_samp_order_by": {
            "rating": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_variance_fields": {
            "rating": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "seller_reviews_variance_order_by": {
            "rating": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "sellers": {
            "Addresses": [
                11,
                {
                    "distinct_on": [
                        23,
                        "[addresses_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        21,
                        "[addresses_order_by!]"
                    ],
                    "where": [
                        14
                    ]
                }
            ],
            "Products": [
                172,
                {
                    "distinct_on": [
                        224,
                        "[products_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        222,
                        "[products_order_by!]"
                    ],
                    "where": [
                        183
                    ]
                }
            ],
            "Products_aggregate": [
                173,
                {
                    "distinct_on": [
                        224,
                        "[products_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        222,
                        "[products_order_by!]"
                    ],
                    "where": [
                        183
                    ]
                }
            ],
            "Receipts": [
                315,
                {
                    "distinct_on": [
                        329,
                        "[sellers_payouts_receipts_out_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        328,
                        "[sellers_payouts_receipts_out_order_by!]"
                    ],
                    "where": [
                        323
                    ]
                }
            ],
            "Receipts_aggregate": [
                316,
                {
                    "distinct_on": [
                        329,
                        "[sellers_payouts_receipts_out_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        328,
                        "[sellers_payouts_receipts_out_order_by!]"
                    ],
                    "where": [
                        323
                    ]
                }
            ],
            "Reviews": [
                271,
                {
                    "distinct_on": [
                        287,
                        "[seller_reviews_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        285,
                        "[seller_reviews_order_by!]"
                    ],
                    "where": [
                        279
                    ]
                }
            ],
            "Reviews_aggregate": [
                272,
                {
                    "distinct_on": [
                        287,
                        "[seller_reviews_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        285,
                        "[seller_reviews_order_by!]"
                    ],
                    "where": [
                        279
                    ]
                }
            ],
            "Seller_users": [
                353,
                {
                    "distinct_on": [
                        361,
                        "[sellers_users_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        359,
                        "[sellers_users_order_by!]"
                    ],
                    "where": [
                        355
                    ]
                }
            ],
            "Shipments": [
                441,
                {
                    "distinct_on": [
                        543,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        497,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        452
                    ]
                }
            ],
            "Shipments_aggregate": [
                442,
                {
                    "distinct_on": [
                        543,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        497,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        452
                    ]
                }
            ],
            "Standard_sizes": [
                248,
                {
                    "distinct_on": [
                        260,
                        "[seller_products_standard_sizes_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        259,
                        "[seller_products_standard_sizes_order_by!]"
                    ],
                    "where": [
                        251
                    ]
                }
            ],
            "company_free_shipping_threshold": [
                156
            ],
            "computed_balance": [
                156
            ],
            "computed_monthly_revenue": [
                156
            ],
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "description": [
                7
            ],
            "extra_images_ids": [
                596
            ],
            "id": [
                596
            ],
            "image_id": [
                596
            ],
            "is_available": [
                0
            ],
            "is_online_payments_enabled": [
                0
            ],
            "min_shipment_products_cost": [
                156
            ],
            "name": [
                7
            ],
            "ops_has_whatsapp": [
                0
            ],
            "ops_phone_number": [
                7
            ],
            "pickup_time_windows_utc": [
                99,
                {
                    "path": [
                        7
                    ]
                }
            ],
            "public_has_whatsapp": [
                0
            ],
            "public_phone_number": [
                7
            ],
            "seller_free_shipping_threshold": [
                156
            ],
            "seller_number": [
                4
            ],
            "shipping_geofence": [
                99,
                {
                    "path": [
                        7
                    ]
                }
            ],
            "__typename": [
                7
            ]
        },
        "sellers_append_input": {
            "pickup_time_windows_utc": [
                99
            ],
            "shipping_geofence": [
                99
            ],
            "__typename": [
                7
            ]
        },
        "sellers_bool_exp": {
            "Addresses": [
                14
            ],
            "Products": [
                183
            ],
            "Products_aggregate": [
                174
            ],
            "Receipts": [
                323
            ],
            "Receipts_aggregate": [
                317
            ],
            "Reviews": [
                279
            ],
            "Reviews_aggregate": [
                273
            ],
            "Seller_users": [
                355
            ],
            "Shipments": [
                452
            ],
            "Shipments_aggregate": [
                443
            ],
            "Standard_sizes": [
                251
            ],
            "_and": [
                308
            ],
            "_not": [
                308
            ],
            "_or": [
                308
            ],
            "company_free_shipping_threshold": [
                157
            ],
            "computed_balance": [
                157
            ],
            "computed_monthly_revenue": [
                157
            ],
            "date_created": [
                579
            ],
            "date_updated": [
                579
            ],
            "description": [
                8
            ],
            "extra_images_ids": [
                597
            ],
            "id": [
                598
            ],
            "image_id": [
                598
            ],
            "is_available": [
                1
            ],
            "is_online_payments_enabled": [
                1
            ],
            "min_shipment_products_cost": [
                157
            ],
            "name": [
                8
            ],
            "ops_has_whatsapp": [
                1
            ],
            "ops_phone_number": [
                8
            ],
            "pickup_time_windows_utc": [
                101
            ],
            "public_has_whatsapp": [
                1
            ],
            "public_phone_number": [
                8
            ],
            "seller_free_shipping_threshold": [
                157
            ],
            "seller_number": [
                5
            ],
            "shipping_geofence": [
                101
            ],
            "__typename": [
                7
            ]
        },
        "sellers_delete_at_path_input": {
            "pickup_time_windows_utc": [
                7
            ],
            "shipping_geofence": [
                7
            ],
            "__typename": [
                7
            ]
        },
        "sellers_delete_elem_input": {
            "pickup_time_windows_utc": [
                4
            ],
            "shipping_geofence": [
                4
            ],
            "__typename": [
                7
            ]
        },
        "sellers_delete_key_input": {
            "pickup_time_windows_utc": [
                7
            ],
            "shipping_geofence": [
                7
            ],
            "__typename": [
                7
            ]
        },
        "sellers_inc_input": {
            "min_shipment_products_cost": [
                156
            ],
            "seller_free_shipping_threshold": [
                156
            ],
            "__typename": [
                7
            ]
        },
        "sellers_mutation_response": {
            "affected_rows": [
                4
            ],
            "returning": [
                306
            ],
            "__typename": [
                7
            ]
        },
        "sellers_order_by": {
            "Addresses_aggregate": [
                12
            ],
            "Products_aggregate": [
                179
            ],
            "Receipts_aggregate": [
                320
            ],
            "Reviews_aggregate": [
                276
            ],
            "Seller_users_aggregate": [
                354
            ],
            "Shipments_aggregate": [
                448
            ],
            "Standard_sizes_aggregate": [
                249
            ],
            "company_free_shipping_threshold": [
                164
            ],
            "computed_balance": [
                164
            ],
            "computed_monthly_revenue": [
                164
            ],
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "description": [
                164
            ],
            "extra_images_ids": [
                164
            ],
            "id": [
                164
            ],
            "image_id": [
                164
            ],
            "is_available": [
                164
            ],
            "is_online_payments_enabled": [
                164
            ],
            "min_shipment_products_cost": [
                164
            ],
            "name": [
                164
            ],
            "ops_has_whatsapp": [
                164
            ],
            "ops_phone_number": [
                164
            ],
            "pickup_time_windows_utc": [
                164
            ],
            "public_has_whatsapp": [
                164
            ],
            "public_phone_number": [
                164
            ],
            "seller_free_shipping_threshold": [
                164
            ],
            "seller_number": [
                164
            ],
            "shipping_geofence": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "sellers_payouts_receipts_out": {
            "Issued_by": [
                158
            ],
            "Paid_by": [
                158
            ],
            "Seller": [
                306
            ],
            "Shipments": [
                441,
                {
                    "distinct_on": [
                        543,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        497,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        452
                    ]
                }
            ],
            "Shipments_aggregate": [
                442,
                {
                    "distinct_on": [
                        543,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        497,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        452
                    ]
                }
            ],
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "id": [
                596
            ],
            "invoice_amount": [
                156
            ],
            "issued_by": [
                596
            ],
            "paid_by": [
                596
            ],
            "payment_timestamp": [
                578
            ],
            "receipt_number": [
                7
            ],
            "seller_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "sellers_payouts_receipts_out_aggregate": {
            "aggregate": [
                319
            ],
            "nodes": [
                315
            ],
            "__typename": [
                7
            ]
        },
        "sellers_payouts_receipts_out_aggregate_bool_exp": {
            "count": [
                318
            ],
            "__typename": [
                7
            ]
        },
        "sellers_payouts_receipts_out_aggregate_bool_exp_count": {
            "arguments": [
                329
            ],
            "distinct": [
                0
            ],
            "filter": [
                323
            ],
            "predicate": [
                5
            ],
            "__typename": [
                7
            ]
        },
        "sellers_payouts_receipts_out_aggregate_fields": {
            "avg": [
                321
            ],
            "count": [
                4,
                {
                    "columns": [
                        329,
                        "[sellers_payouts_receipts_out_select_column!]"
                    ],
                    "distinct": [
                        0
                    ]
                }
            ],
            "max": [
                324
            ],
            "min": [
                326
            ],
            "stddev": [
                330
            ],
            "stddev_pop": [
                332
            ],
            "stddev_samp": [
                334
            ],
            "sum": [
                338
            ],
            "var_pop": [
                340
            ],
            "var_samp": [
                342
            ],
            "variance": [
                344
            ],
            "__typename": [
                7
            ]
        },
        "sellers_payouts_receipts_out_aggregate_order_by": {
            "avg": [
                322
            ],
            "count": [
                164
            ],
            "max": [
                325
            ],
            "min": [
                327
            ],
            "stddev": [
                331
            ],
            "stddev_pop": [
                333
            ],
            "stddev_samp": [
                335
            ],
            "sum": [
                339
            ],
            "var_pop": [
                341
            ],
            "var_samp": [
                343
            ],
            "variance": [
                345
            ],
            "__typename": [
                7
            ]
        },
        "sellers_payouts_receipts_out_avg_fields": {
            "invoice_amount": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "sellers_payouts_receipts_out_avg_order_by": {
            "invoice_amount": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "sellers_payouts_receipts_out_bool_exp": {
            "Issued_by": [
                159
            ],
            "Paid_by": [
                159
            ],
            "Seller": [
                308
            ],
            "Shipments": [
                452
            ],
            "Shipments_aggregate": [
                443
            ],
            "_and": [
                323
            ],
            "_not": [
                323
            ],
            "_or": [
                323
            ],
            "date_created": [
                579
            ],
            "date_updated": [
                579
            ],
            "id": [
                598
            ],
            "invoice_amount": [
                157
            ],
            "issued_by": [
                598
            ],
            "paid_by": [
                598
            ],
            "payment_timestamp": [
                579
            ],
            "receipt_number": [
                8
            ],
            "seller_id": [
                598
            ],
            "__typename": [
                7
            ]
        },
        "sellers_payouts_receipts_out_max_fields": {
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "id": [
                596
            ],
            "invoice_amount": [
                156
            ],
            "issued_by": [
                596
            ],
            "paid_by": [
                596
            ],
            "payment_timestamp": [
                578
            ],
            "receipt_number": [
                7
            ],
            "seller_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "sellers_payouts_receipts_out_max_order_by": {
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "id": [
                164
            ],
            "invoice_amount": [
                164
            ],
            "issued_by": [
                164
            ],
            "paid_by": [
                164
            ],
            "payment_timestamp": [
                164
            ],
            "receipt_number": [
                164
            ],
            "seller_id": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "sellers_payouts_receipts_out_min_fields": {
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "id": [
                596
            ],
            "invoice_amount": [
                156
            ],
            "issued_by": [
                596
            ],
            "paid_by": [
                596
            ],
            "payment_timestamp": [
                578
            ],
            "receipt_number": [
                7
            ],
            "seller_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "sellers_payouts_receipts_out_min_order_by": {
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "id": [
                164
            ],
            "invoice_amount": [
                164
            ],
            "issued_by": [
                164
            ],
            "paid_by": [
                164
            ],
            "payment_timestamp": [
                164
            ],
            "receipt_number": [
                164
            ],
            "seller_id": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "sellers_payouts_receipts_out_order_by": {
            "Issued_by": [
                160
            ],
            "Paid_by": [
                160
            ],
            "Seller": [
                314
            ],
            "Shipments_aggregate": [
                448
            ],
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "id": [
                164
            ],
            "invoice_amount": [
                164
            ],
            "issued_by": [
                164
            ],
            "paid_by": [
                164
            ],
            "payment_timestamp": [
                164
            ],
            "receipt_number": [
                164
            ],
            "seller_id": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "sellers_payouts_receipts_out_select_column": {},
        "sellers_payouts_receipts_out_stddev_fields": {
            "invoice_amount": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "sellers_payouts_receipts_out_stddev_order_by": {
            "invoice_amount": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "sellers_payouts_receipts_out_stddev_pop_fields": {
            "invoice_amount": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "sellers_payouts_receipts_out_stddev_pop_order_by": {
            "invoice_amount": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "sellers_payouts_receipts_out_stddev_samp_fields": {
            "invoice_amount": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "sellers_payouts_receipts_out_stddev_samp_order_by": {
            "invoice_amount": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "sellers_payouts_receipts_out_stream_cursor_input": {
            "initial_value": [
                337
            ],
            "ordering": [
                37
            ],
            "__typename": [
                7
            ]
        },
        "sellers_payouts_receipts_out_stream_cursor_value_input": {
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "id": [
                596
            ],
            "invoice_amount": [
                156
            ],
            "issued_by": [
                596
            ],
            "paid_by": [
                596
            ],
            "payment_timestamp": [
                578
            ],
            "receipt_number": [
                7
            ],
            "seller_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "sellers_payouts_receipts_out_sum_fields": {
            "invoice_amount": [
                156
            ],
            "__typename": [
                7
            ]
        },
        "sellers_payouts_receipts_out_sum_order_by": {
            "invoice_amount": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "sellers_payouts_receipts_out_var_pop_fields": {
            "invoice_amount": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "sellers_payouts_receipts_out_var_pop_order_by": {
            "invoice_amount": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "sellers_payouts_receipts_out_var_samp_fields": {
            "invoice_amount": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "sellers_payouts_receipts_out_var_samp_order_by": {
            "invoice_amount": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "sellers_payouts_receipts_out_variance_fields": {
            "invoice_amount": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "sellers_payouts_receipts_out_variance_order_by": {
            "invoice_amount": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "sellers_pk_columns_input": {
            "id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "sellers_prepend_input": {
            "pickup_time_windows_utc": [
                99
            ],
            "shipping_geofence": [
                99
            ],
            "__typename": [
                7
            ]
        },
        "sellers_select_column": {},
        "sellers_set_input": {
            "date_updated": [
                578
            ],
            "description": [
                7
            ],
            "extra_images_ids": [
                596
            ],
            "image_id": [
                596
            ],
            "is_available": [
                0
            ],
            "min_shipment_products_cost": [
                156
            ],
            "name": [
                7
            ],
            "ops_phone_number": [
                7
            ],
            "pickup_time_windows_utc": [
                99
            ],
            "public_phone_number": [
                7
            ],
            "seller_free_shipping_threshold": [
                156
            ],
            "shipping_geofence": [
                99
            ],
            "__typename": [
                7
            ]
        },
        "sellers_stream_cursor_input": {
            "initial_value": [
                351
            ],
            "ordering": [
                37
            ],
            "__typename": [
                7
            ]
        },
        "sellers_stream_cursor_value_input": {
            "company_free_shipping_threshold": [
                156
            ],
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "description": [
                7
            ],
            "extra_images_ids": [
                596
            ],
            "id": [
                596
            ],
            "image_id": [
                596
            ],
            "is_available": [
                0
            ],
            "is_online_payments_enabled": [
                0
            ],
            "min_shipment_products_cost": [
                156
            ],
            "name": [
                7
            ],
            "ops_has_whatsapp": [
                0
            ],
            "ops_phone_number": [
                7
            ],
            "pickup_time_windows_utc": [
                99
            ],
            "public_has_whatsapp": [
                0
            ],
            "public_phone_number": [
                7
            ],
            "seller_free_shipping_threshold": [
                156
            ],
            "seller_number": [
                4
            ],
            "shipping_geofence": [
                99
            ],
            "__typename": [
                7
            ]
        },
        "sellers_updates": {
            "_append": [
                307
            ],
            "_delete_at_path": [
                309
            ],
            "_delete_elem": [
                310
            ],
            "_delete_key": [
                311
            ],
            "_inc": [
                312
            ],
            "_prepend": [
                347
            ],
            "_set": [
                349
            ],
            "where": [
                308
            ],
            "__typename": [
                7
            ]
        },
        "sellers_users": {
            "Seller": [
                306
            ],
            "has_whatsapp": [
                0
            ],
            "id": [
                596
            ],
            "mobile_device_token": [
                7
            ],
            "name": [
                7
            ],
            "phone_number": [
                7
            ],
            "seller_id": [
                596
            ],
            "web_device_token": [
                7
            ],
            "__typename": [
                7
            ]
        },
        "sellers_users_aggregate_order_by": {
            "count": [
                164
            ],
            "max": [
                356
            ],
            "min": [
                357
            ],
            "__typename": [
                7
            ]
        },
        "sellers_users_bool_exp": {
            "Seller": [
                308
            ],
            "_and": [
                355
            ],
            "_not": [
                355
            ],
            "_or": [
                355
            ],
            "has_whatsapp": [
                1
            ],
            "id": [
                598
            ],
            "mobile_device_token": [
                8
            ],
            "name": [
                8
            ],
            "phone_number": [
                8
            ],
            "seller_id": [
                598
            ],
            "web_device_token": [
                8
            ],
            "__typename": [
                7
            ]
        },
        "sellers_users_max_order_by": {
            "id": [
                164
            ],
            "mobile_device_token": [
                164
            ],
            "name": [
                164
            ],
            "phone_number": [
                164
            ],
            "seller_id": [
                164
            ],
            "web_device_token": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "sellers_users_min_order_by": {
            "id": [
                164
            ],
            "mobile_device_token": [
                164
            ],
            "name": [
                164
            ],
            "phone_number": [
                164
            ],
            "seller_id": [
                164
            ],
            "web_device_token": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "sellers_users_mutation_response": {
            "affected_rows": [
                4
            ],
            "returning": [
                353
            ],
            "__typename": [
                7
            ]
        },
        "sellers_users_order_by": {
            "Seller": [
                314
            ],
            "has_whatsapp": [
                164
            ],
            "id": [
                164
            ],
            "mobile_device_token": [
                164
            ],
            "name": [
                164
            ],
            "phone_number": [
                164
            ],
            "seller_id": [
                164
            ],
            "web_device_token": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "sellers_users_pk_columns_input": {
            "id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "sellers_users_select_column": {},
        "sellers_users_set_input": {
            "mobile_device_token": [
                7
            ],
            "name": [
                7
            ],
            "web_device_token": [
                7
            ],
            "__typename": [
                7
            ]
        },
        "sellers_users_stream_cursor_input": {
            "initial_value": [
                364
            ],
            "ordering": [
                37
            ],
            "__typename": [
                7
            ]
        },
        "sellers_users_stream_cursor_value_input": {
            "has_whatsapp": [
                0
            ],
            "id": [
                596
            ],
            "mobile_device_token": [
                7
            ],
            "name": [
                7
            ],
            "phone_number": [
                7
            ],
            "seller_id": [
                596
            ],
            "web_device_token": [
                7
            ],
            "__typename": [
                7
            ]
        },
        "sellers_users_updates": {
            "_set": [
                362
            ],
            "where": [
                355
            ],
            "__typename": [
                7
            ]
        },
        "shipment_note": {},
        "shipment_note_comparison_exp": {
            "_eq": [
                366
            ],
            "_gt": [
                366
            ],
            "_gte": [
                366
            ],
            "_in": [
                366
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                366
            ],
            "_lte": [
                366
            ],
            "_neq": [
                366
            ],
            "_nin": [
                366
            ],
            "__typename": [
                7
            ]
        },
        "shipment_payment_status": {},
        "shipment_payment_status_comparison_exp": {
            "_eq": [
                368
            ],
            "_gt": [
                368
            ],
            "_gte": [
                368
            ],
            "_in": [
                368
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                368
            ],
            "_lte": [
                368
            ],
            "_neq": [
                368
            ],
            "_nin": [
                368
            ],
            "__typename": [
                7
            ]
        },
        "shipment_product_item_extras": {
            "Extra": [
                185
            ],
            "Shipment_item": [
                397
            ],
            "calculated_price": [
                156
            ],
            "id": [
                596
            ],
            "product_extra_id": [
                596
            ],
            "quantity": [
                156
            ],
            "shipment_product_item_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "shipment_product_item_extras_aggregate_order_by": {
            "avg": [
                373
            ],
            "count": [
                164
            ],
            "max": [
                378
            ],
            "min": [
                379
            ],
            "stddev": [
                386
            ],
            "stddev_pop": [
                387
            ],
            "stddev_samp": [
                388
            ],
            "sum": [
                391
            ],
            "var_pop": [
                394
            ],
            "var_samp": [
                395
            ],
            "variance": [
                396
            ],
            "__typename": [
                7
            ]
        },
        "shipment_product_item_extras_arr_rel_insert_input": {
            "data": [
                377
            ],
            "on_conflict": [
                381
            ],
            "__typename": [
                7
            ]
        },
        "shipment_product_item_extras_avg_order_by": {
            "calculated_price": [
                164
            ],
            "quantity": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipment_product_item_extras_bool_exp": {
            "Extra": [
                189
            ],
            "Shipment_item": [
                406
            ],
            "_and": [
                374
            ],
            "_not": [
                374
            ],
            "_or": [
                374
            ],
            "calculated_price": [
                157
            ],
            "id": [
                598
            ],
            "product_extra_id": [
                598
            ],
            "quantity": [
                157
            ],
            "shipment_product_item_id": [
                598
            ],
            "__typename": [
                7
            ]
        },
        "shipment_product_item_extras_constraint": {},
        "shipment_product_item_extras_inc_input": {
            "quantity": [
                156
            ],
            "__typename": [
                7
            ]
        },
        "shipment_product_item_extras_insert_input": {
            "Extra": [
                196
            ],
            "Shipment_item": [
                415
            ],
            "product_extra_id": [
                596
            ],
            "quantity": [
                156
            ],
            "shipment_product_item_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "shipment_product_item_extras_max_order_by": {
            "calculated_price": [
                164
            ],
            "id": [
                164
            ],
            "product_extra_id": [
                164
            ],
            "quantity": [
                164
            ],
            "shipment_product_item_id": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipment_product_item_extras_min_order_by": {
            "calculated_price": [
                164
            ],
            "id": [
                164
            ],
            "product_extra_id": [
                164
            ],
            "quantity": [
                164
            ],
            "shipment_product_item_id": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipment_product_item_extras_mutation_response": {
            "affected_rows": [
                4
            ],
            "returning": [
                370
            ],
            "__typename": [
                7
            ]
        },
        "shipment_product_item_extras_on_conflict": {
            "constraint": [
                375
            ],
            "update_columns": [
                392
            ],
            "where": [
                374
            ],
            "__typename": [
                7
            ]
        },
        "shipment_product_item_extras_order_by": {
            "Extra": [
                198
            ],
            "Shipment_item": [
                417
            ],
            "calculated_price": [
                164
            ],
            "id": [
                164
            ],
            "product_extra_id": [
                164
            ],
            "quantity": [
                164
            ],
            "shipment_product_item_id": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipment_product_item_extras_pk_columns_input": {
            "id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "shipment_product_item_extras_select_column": {},
        "shipment_product_item_extras_set_input": {
            "quantity": [
                156
            ],
            "__typename": [
                7
            ]
        },
        "shipment_product_item_extras_stddev_order_by": {
            "calculated_price": [
                164
            ],
            "quantity": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipment_product_item_extras_stddev_pop_order_by": {
            "calculated_price": [
                164
            ],
            "quantity": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipment_product_item_extras_stddev_samp_order_by": {
            "calculated_price": [
                164
            ],
            "quantity": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipment_product_item_extras_stream_cursor_input": {
            "initial_value": [
                390
            ],
            "ordering": [
                37
            ],
            "__typename": [
                7
            ]
        },
        "shipment_product_item_extras_stream_cursor_value_input": {
            "calculated_price": [
                156
            ],
            "id": [
                596
            ],
            "product_extra_id": [
                596
            ],
            "quantity": [
                156
            ],
            "shipment_product_item_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "shipment_product_item_extras_sum_order_by": {
            "calculated_price": [
                164
            ],
            "quantity": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipment_product_item_extras_update_column": {},
        "shipment_product_item_extras_updates": {
            "_inc": [
                376
            ],
            "_set": [
                385
            ],
            "where": [
                374
            ],
            "__typename": [
                7
            ]
        },
        "shipment_product_item_extras_var_pop_order_by": {
            "calculated_price": [
                164
            ],
            "quantity": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipment_product_item_extras_var_samp_order_by": {
            "calculated_price": [
                164
            ],
            "quantity": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipment_product_item_extras_variance_order_by": {
            "calculated_price": [
                164
            ],
            "quantity": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items": {
            "Product": [
                172
            ],
            "Product_extras": [
                370,
                {
                    "distinct_on": [
                        384,
                        "[shipment_product_item_extras_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        382,
                        "[shipment_product_item_extras_order_by!]"
                    ],
                    "where": [
                        374
                    ]
                }
            ],
            "Shipment": [
                441
            ],
            "calculated_price": [
                156
            ],
            "calculated_seller_price": [
                156
            ],
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "id": [
                596
            ],
            "product_id": [
                596
            ],
            "quantity": [
                156
            ],
            "shipment_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_aggregate": {
            "aggregate": [
                401
            ],
            "nodes": [
                397
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_aggregate_bool_exp": {
            "count": [
                400
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_aggregate_bool_exp_count": {
            "arguments": [
                419
            ],
            "distinct": [
                0
            ],
            "filter": [
                406
            ],
            "predicate": [
                5
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_aggregate_fields": {
            "avg": [
                404
            ],
            "count": [
                4,
                {
                    "columns": [
                        419,
                        "[shipment_products_items_select_column!]"
                    ],
                    "distinct": [
                        0
                    ]
                }
            ],
            "max": [
                410
            ],
            "min": [
                412
            ],
            "stddev": [
                421
            ],
            "stddev_pop": [
                423
            ],
            "stddev_samp": [
                425
            ],
            "sum": [
                429
            ],
            "var_pop": [
                433
            ],
            "var_samp": [
                435
            ],
            "variance": [
                437
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_aggregate_order_by": {
            "avg": [
                405
            ],
            "count": [
                164
            ],
            "max": [
                411
            ],
            "min": [
                413
            ],
            "stddev": [
                422
            ],
            "stddev_pop": [
                424
            ],
            "stddev_samp": [
                426
            ],
            "sum": [
                430
            ],
            "var_pop": [
                434
            ],
            "var_samp": [
                436
            ],
            "variance": [
                438
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_arr_rel_insert_input": {
            "data": [
                409
            ],
            "on_conflict": [
                416
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_avg_fields": {
            "calculated_price": [
                2
            ],
            "calculated_seller_price": [
                2
            ],
            "quantity": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_avg_order_by": {
            "calculated_price": [
                164
            ],
            "calculated_seller_price": [
                164
            ],
            "quantity": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_bool_exp": {
            "Product": [
                183
            ],
            "Product_extras": [
                374
            ],
            "Shipment": [
                452
            ],
            "_and": [
                406
            ],
            "_not": [
                406
            ],
            "_or": [
                406
            ],
            "calculated_price": [
                157
            ],
            "calculated_seller_price": [
                157
            ],
            "date_created": [
                579
            ],
            "date_updated": [
                579
            ],
            "id": [
                598
            ],
            "product_id": [
                598
            ],
            "quantity": [
                157
            ],
            "shipment_id": [
                598
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_constraint": {},
        "shipment_products_items_inc_input": {
            "quantity": [
                156
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_insert_input": {
            "Product": [
                220
            ],
            "Product_extras": [
                372
            ],
            "id": [
                596
            ],
            "product_id": [
                596
            ],
            "quantity": [
                156
            ],
            "shipment_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_max_fields": {
            "calculated_price": [
                156
            ],
            "calculated_seller_price": [
                156
            ],
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "id": [
                596
            ],
            "product_id": [
                596
            ],
            "quantity": [
                156
            ],
            "shipment_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_max_order_by": {
            "calculated_price": [
                164
            ],
            "calculated_seller_price": [
                164
            ],
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "id": [
                164
            ],
            "product_id": [
                164
            ],
            "quantity": [
                164
            ],
            "shipment_id": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_min_fields": {
            "calculated_price": [
                156
            ],
            "calculated_seller_price": [
                156
            ],
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "id": [
                596
            ],
            "product_id": [
                596
            ],
            "quantity": [
                156
            ],
            "shipment_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_min_order_by": {
            "calculated_price": [
                164
            ],
            "calculated_seller_price": [
                164
            ],
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "id": [
                164
            ],
            "product_id": [
                164
            ],
            "quantity": [
                164
            ],
            "shipment_id": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_mutation_response": {
            "affected_rows": [
                4
            ],
            "returning": [
                397
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_obj_rel_insert_input": {
            "data": [
                409
            ],
            "on_conflict": [
                416
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_on_conflict": {
            "constraint": [
                407
            ],
            "update_columns": [
                431
            ],
            "where": [
                406
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_order_by": {
            "Product": [
                222
            ],
            "Product_extras_aggregate": [
                371
            ],
            "Shipment": [
                497
            ],
            "calculated_price": [
                164
            ],
            "calculated_seller_price": [
                164
            ],
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "id": [
                164
            ],
            "product_id": [
                164
            ],
            "quantity": [
                164
            ],
            "shipment_id": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_pk_columns_input": {
            "id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_select_column": {},
        "shipment_products_items_set_input": {
            "is_deleted": [
                0
            ],
            "quantity": [
                156
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_stddev_fields": {
            "calculated_price": [
                2
            ],
            "calculated_seller_price": [
                2
            ],
            "quantity": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_stddev_order_by": {
            "calculated_price": [
                164
            ],
            "calculated_seller_price": [
                164
            ],
            "quantity": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_stddev_pop_fields": {
            "calculated_price": [
                2
            ],
            "calculated_seller_price": [
                2
            ],
            "quantity": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_stddev_pop_order_by": {
            "calculated_price": [
                164
            ],
            "calculated_seller_price": [
                164
            ],
            "quantity": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_stddev_samp_fields": {
            "calculated_price": [
                2
            ],
            "calculated_seller_price": [
                2
            ],
            "quantity": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_stddev_samp_order_by": {
            "calculated_price": [
                164
            ],
            "calculated_seller_price": [
                164
            ],
            "quantity": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_stream_cursor_input": {
            "initial_value": [
                428
            ],
            "ordering": [
                37
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_stream_cursor_value_input": {
            "calculated_price": [
                156
            ],
            "calculated_seller_price": [
                156
            ],
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "id": [
                596
            ],
            "product_id": [
                596
            ],
            "quantity": [
                156
            ],
            "shipment_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_sum_fields": {
            "calculated_price": [
                156
            ],
            "calculated_seller_price": [
                156
            ],
            "quantity": [
                156
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_sum_order_by": {
            "calculated_price": [
                164
            ],
            "calculated_seller_price": [
                164
            ],
            "quantity": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_update_column": {},
        "shipment_products_items_updates": {
            "_inc": [
                408
            ],
            "_set": [
                420
            ],
            "where": [
                406
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_var_pop_fields": {
            "calculated_price": [
                2
            ],
            "calculated_seller_price": [
                2
            ],
            "quantity": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_var_pop_order_by": {
            "calculated_price": [
                164
            ],
            "calculated_seller_price": [
                164
            ],
            "quantity": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_var_samp_fields": {
            "calculated_price": [
                2
            ],
            "calculated_seller_price": [
                2
            ],
            "quantity": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_var_samp_order_by": {
            "calculated_price": [
                164
            ],
            "calculated_seller_price": [
                164
            ],
            "quantity": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_variance_fields": {
            "calculated_price": [
                2
            ],
            "calculated_seller_price": [
                2
            ],
            "quantity": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "shipment_products_items_variance_order_by": {
            "calculated_price": [
                164
            ],
            "calculated_seller_price": [
                164
            ],
            "quantity": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipment_status": {},
        "shipment_status_comparison_exp": {
            "_eq": [
                439
            ],
            "_gt": [
                439
            ],
            "_gte": [
                439
            ],
            "_in": [
                439
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                439
            ],
            "_lte": [
                439
            ],
            "_neq": [
                439
            ],
            "_nin": [
                439
            ],
            "__typename": [
                7
            ]
        },
        "shipments": {
            "Assigned_driver": [
                40
            ],
            "Boxes": [
                453,
                {
                    "distinct_on": [
                        466,
                        "[shipments_boxes_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        464,
                        "[shipments_boxes_order_by!]"
                    ],
                    "where": [
                        456
                    ]
                }
            ],
            "Buyer": [
                31
            ],
            "Destination_address": [
                11
            ],
            "Messages": [
                102,
                {
                    "distinct_on": [
                        135,
                        "[messages_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        133,
                        "[messages_order_by!]"
                    ],
                    "where": [
                        108
                    ]
                }
            ],
            "Messages_aggregate": [
                103,
                {
                    "distinct_on": [
                        135,
                        "[messages_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        133,
                        "[messages_order_by!]"
                    ],
                    "where": [
                        108
                    ]
                }
            ],
            "Notes": [
                488,
                {
                    "distinct_on": [
                        494,
                        "[shipments_notes_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        493,
                        "[shipments_notes_order_by!]"
                    ],
                    "where": [
                        490
                    ]
                }
            ],
            "Payments": [
                498,
                {
                    "distinct_on": [
                        505,
                        "[shipments_payments_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        504,
                        "[shipments_payments_order_by!]"
                    ],
                    "where": [
                        501
                    ]
                }
            ],
            "Products": [
                397,
                {
                    "distinct_on": [
                        419,
                        "[shipment_products_items_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        417,
                        "[shipment_products_items_order_by!]"
                    ],
                    "where": [
                        406
                    ]
                }
            ],
            "Products_aggregate": [
                398,
                {
                    "distinct_on": [
                        419,
                        "[shipment_products_items_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        417,
                        "[shipment_products_items_order_by!]"
                    ],
                    "where": [
                        406
                    ]
                }
            ],
            "Routes_steps": [
                524,
                {
                    "distinct_on": [
                        531,
                        "[shipments_routes_steps_shipments_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        530,
                        "[shipments_routes_steps_shipments_order_by!]"
                    ],
                    "where": [
                        527
                    ]
                }
            ],
            "Seller": [
                306
            ],
            "Undefined_buyer": [
                582
            ],
            "allowed_payment_methods": [
                167
            ],
            "amount_paid": [
                156
            ],
            "assigned_driver_id": [
                596
            ],
            "base_shipping_cost": [
                156
            ],
            "buyer_id": [
                596
            ],
            "cancellation_object": [
                99,
                {
                    "path": [
                        7
                    ]
                }
            ],
            "company_discount": [
                156
            ],
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "delivered_timestamp": [
                578
            ],
            "destination_address_id": [
                596
            ],
            "dynamic_shipping_cost": [
                156
            ],
            "eta": [
                578
            ],
            "eta_updated": [
                578
            ],
            "id": [
                596
            ],
            "is_active": [
                0
            ],
            "is_company_free_shipping": [
                0
            ],
            "is_seller_free_shipping": [
                0
            ],
            "payment_status": [
                368
            ],
            "preferred_delivery_time_windows_utc": [
                99,
                {
                    "path": [
                        7
                    ]
                }
            ],
            "products_cost": [
                156
            ],
            "products_cost_seller": [
                156
            ],
            "products_paid_in_advance": [
                0
            ],
            "ready_time": [
                578
            ],
            "required_amount": [
                156
            ],
            "returned_timestamp": [
                578
            ],
            "seller_discount": [
                156
            ],
            "seller_id": [
                596
            ],
            "seller_payout_receipt_out_id": [
                596
            ],
            "shipment_number": [
                7
            ],
            "shipping_cost": [
                156
            ],
            "status": [
                439
            ],
            "total_volume_cm3": [
                156
            ],
            "tracking_encryption_string": [
                7
            ],
            "undefined_buyer_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "shipments_aggregate": {
            "aggregate": [
                447
            ],
            "nodes": [
                441
            ],
            "__typename": [
                7
            ]
        },
        "shipments_aggregate_bool_exp": {
            "bool_and": [
                444
            ],
            "bool_or": [
                445
            ],
            "count": [
                446
            ],
            "__typename": [
                7
            ]
        },
        "shipments_aggregate_bool_exp_bool_and": {
            "arguments": [
                544
            ],
            "distinct": [
                0
            ],
            "filter": [
                452
            ],
            "predicate": [
                1
            ],
            "__typename": [
                7
            ]
        },
        "shipments_aggregate_bool_exp_bool_or": {
            "arguments": [
                545
            ],
            "distinct": [
                0
            ],
            "filter": [
                452
            ],
            "predicate": [
                1
            ],
            "__typename": [
                7
            ]
        },
        "shipments_aggregate_bool_exp_count": {
            "arguments": [
                543
            ],
            "distinct": [
                0
            ],
            "filter": [
                452
            ],
            "predicate": [
                5
            ],
            "__typename": [
                7
            ]
        },
        "shipments_aggregate_fields": {
            "avg": [
                450
            ],
            "count": [
                4,
                {
                    "columns": [
                        543,
                        "[shipments_select_column!]"
                    ],
                    "distinct": [
                        0
                    ]
                }
            ],
            "max": [
                483
            ],
            "min": [
                485
            ],
            "stddev": [
                547
            ],
            "stddev_pop": [
                549
            ],
            "stddev_samp": [
                551
            ],
            "sum": [
                555
            ],
            "var_pop": [
                558
            ],
            "var_samp": [
                560
            ],
            "variance": [
                562
            ],
            "__typename": [
                7
            ]
        },
        "shipments_aggregate_order_by": {
            "avg": [
                451
            ],
            "count": [
                164
            ],
            "max": [
                484
            ],
            "min": [
                486
            ],
            "stddev": [
                548
            ],
            "stddev_pop": [
                550
            ],
            "stddev_samp": [
                552
            ],
            "sum": [
                556
            ],
            "var_pop": [
                559
            ],
            "var_samp": [
                561
            ],
            "variance": [
                563
            ],
            "__typename": [
                7
            ]
        },
        "shipments_append_input": {
            "preferred_delivery_time_windows_utc": [
                99
            ],
            "__typename": [
                7
            ]
        },
        "shipments_avg_fields": {
            "amount_paid": [
                2
            ],
            "base_shipping_cost": [
                2
            ],
            "company_discount": [
                2
            ],
            "dynamic_shipping_cost": [
                2
            ],
            "products_cost": [
                2
            ],
            "products_cost_seller": [
                2
            ],
            "required_amount": [
                2
            ],
            "seller_discount": [
                2
            ],
            "shipping_cost": [
                2
            ],
            "total_volume_cm3": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "shipments_avg_order_by": {
            "amount_paid": [
                164
            ],
            "base_shipping_cost": [
                164
            ],
            "company_discount": [
                164
            ],
            "dynamic_shipping_cost": [
                164
            ],
            "products_cost": [
                164
            ],
            "products_cost_seller": [
                164
            ],
            "required_amount": [
                164
            ],
            "seller_discount": [
                164
            ],
            "shipping_cost": [
                164
            ],
            "total_volume_cm3": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_bool_exp": {
            "Assigned_driver": [
                41
            ],
            "Boxes": [
                456
            ],
            "Buyer": [
                32
            ],
            "Destination_address": [
                14
            ],
            "Messages": [
                108
            ],
            "Messages_aggregate": [
                104
            ],
            "Notes": [
                490
            ],
            "Payments": [
                501
            ],
            "Products": [
                406
            ],
            "Products_aggregate": [
                399
            ],
            "Routes_steps": [
                527
            ],
            "Seller": [
                308
            ],
            "Undefined_buyer": [
                583
            ],
            "_and": [
                452
            ],
            "_not": [
                452
            ],
            "_or": [
                452
            ],
            "allowed_payment_methods": [
                168
            ],
            "amount_paid": [
                157
            ],
            "assigned_driver_id": [
                598
            ],
            "base_shipping_cost": [
                157
            ],
            "buyer_id": [
                598
            ],
            "cancellation_object": [
                101
            ],
            "company_discount": [
                157
            ],
            "date_created": [
                579
            ],
            "date_updated": [
                579
            ],
            "delivered_timestamp": [
                579
            ],
            "destination_address_id": [
                598
            ],
            "dynamic_shipping_cost": [
                157
            ],
            "eta": [
                579
            ],
            "eta_updated": [
                579
            ],
            "id": [
                598
            ],
            "is_active": [
                1
            ],
            "is_company_free_shipping": [
                1
            ],
            "is_seller_free_shipping": [
                1
            ],
            "payment_status": [
                369
            ],
            "preferred_delivery_time_windows_utc": [
                101
            ],
            "products_cost": [
                157
            ],
            "products_cost_seller": [
                157
            ],
            "products_paid_in_advance": [
                1
            ],
            "ready_time": [
                579
            ],
            "required_amount": [
                157
            ],
            "returned_timestamp": [
                579
            ],
            "seller_discount": [
                157
            ],
            "seller_id": [
                598
            ],
            "seller_payout_receipt_out_id": [
                598
            ],
            "shipment_number": [
                8
            ],
            "shipping_cost": [
                157
            ],
            "status": [
                440
            ],
            "total_volume_cm3": [
                157
            ],
            "tracking_encryption_string": [
                8
            ],
            "undefined_buyer_id": [
                598
            ],
            "__typename": [
                7
            ]
        },
        "shipments_boxes": {
            "Shipment": [
                441
            ],
            "Standard_size": [
                248
            ],
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "description": [
                7
            ],
            "dimensions_cm": [
                38
            ],
            "id": [
                596
            ],
            "name": [
                7
            ],
            "price": [
                156
            ],
            "quantity": [
                156
            ],
            "shipment_id": [
                596
            ],
            "standard_size_id": [
                596
            ],
            "volume_cm3": [
                156
            ],
            "__typename": [
                7
            ]
        },
        "shipments_boxes_aggregate_order_by": {
            "avg": [
                455
            ],
            "count": [
                164
            ],
            "max": [
                460
            ],
            "min": [
                461
            ],
            "stddev": [
                468
            ],
            "stddev_pop": [
                469
            ],
            "stddev_samp": [
                470
            ],
            "sum": [
                473
            ],
            "var_pop": [
                476
            ],
            "var_samp": [
                477
            ],
            "variance": [
                478
            ],
            "__typename": [
                7
            ]
        },
        "shipments_boxes_avg_order_by": {
            "price": [
                164
            ],
            "quantity": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_boxes_bool_exp": {
            "Shipment": [
                452
            ],
            "Standard_size": [
                251
            ],
            "_and": [
                456
            ],
            "_not": [
                456
            ],
            "_or": [
                456
            ],
            "date_created": [
                579
            ],
            "date_updated": [
                579
            ],
            "description": [
                8
            ],
            "dimensions_cm": [
                39
            ],
            "id": [
                598
            ],
            "name": [
                8
            ],
            "price": [
                157
            ],
            "quantity": [
                157
            ],
            "shipment_id": [
                598
            ],
            "standard_size_id": [
                598
            ],
            "volume_cm3": [
                157
            ],
            "__typename": [
                7
            ]
        },
        "shipments_boxes_constraint": {},
        "shipments_boxes_inc_input": {
            "price": [
                156
            ],
            "quantity": [
                156
            ],
            "__typename": [
                7
            ]
        },
        "shipments_boxes_insert_input": {
            "Standard_size": [
                257
            ],
            "description": [
                7
            ],
            "dimensions_cm": [
                38
            ],
            "name": [
                7
            ],
            "price": [
                156
            ],
            "quantity": [
                156
            ],
            "shipment_id": [
                596
            ],
            "standard_size_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "shipments_boxes_max_order_by": {
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "description": [
                164
            ],
            "dimensions_cm": [
                164
            ],
            "id": [
                164
            ],
            "name": [
                164
            ],
            "price": [
                164
            ],
            "quantity": [
                164
            ],
            "shipment_id": [
                164
            ],
            "standard_size_id": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_boxes_min_order_by": {
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "description": [
                164
            ],
            "dimensions_cm": [
                164
            ],
            "id": [
                164
            ],
            "name": [
                164
            ],
            "price": [
                164
            ],
            "quantity": [
                164
            ],
            "shipment_id": [
                164
            ],
            "standard_size_id": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_boxes_mutation_response": {
            "affected_rows": [
                4
            ],
            "returning": [
                453
            ],
            "__typename": [
                7
            ]
        },
        "shipments_boxes_on_conflict": {
            "constraint": [
                457
            ],
            "update_columns": [
                474
            ],
            "where": [
                456
            ],
            "__typename": [
                7
            ]
        },
        "shipments_boxes_order_by": {
            "Shipment": [
                497
            ],
            "Standard_size": [
                259
            ],
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "description": [
                164
            ],
            "dimensions_cm": [
                164
            ],
            "id": [
                164
            ],
            "name": [
                164
            ],
            "price": [
                164
            ],
            "quantity": [
                164
            ],
            "shipment_id": [
                164
            ],
            "standard_size_id": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_boxes_pk_columns_input": {
            "id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "shipments_boxes_select_column": {},
        "shipments_boxes_set_input": {
            "description": [
                7
            ],
            "is_deleted": [
                0
            ],
            "name": [
                7
            ],
            "price": [
                156
            ],
            "quantity": [
                156
            ],
            "__typename": [
                7
            ]
        },
        "shipments_boxes_stddev_order_by": {
            "price": [
                164
            ],
            "quantity": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_boxes_stddev_pop_order_by": {
            "price": [
                164
            ],
            "quantity": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_boxes_stddev_samp_order_by": {
            "price": [
                164
            ],
            "quantity": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_boxes_stream_cursor_input": {
            "initial_value": [
                472
            ],
            "ordering": [
                37
            ],
            "__typename": [
                7
            ]
        },
        "shipments_boxes_stream_cursor_value_input": {
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "description": [
                7
            ],
            "dimensions_cm": [
                38
            ],
            "id": [
                596
            ],
            "name": [
                7
            ],
            "price": [
                156
            ],
            "quantity": [
                156
            ],
            "shipment_id": [
                596
            ],
            "standard_size_id": [
                596
            ],
            "volume_cm3": [
                156
            ],
            "__typename": [
                7
            ]
        },
        "shipments_boxes_sum_order_by": {
            "price": [
                164
            ],
            "quantity": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_boxes_update_column": {},
        "shipments_boxes_updates": {
            "_inc": [
                458
            ],
            "_set": [
                467
            ],
            "where": [
                456
            ],
            "__typename": [
                7
            ]
        },
        "shipments_boxes_var_pop_order_by": {
            "price": [
                164
            ],
            "quantity": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_boxes_var_samp_order_by": {
            "price": [
                164
            ],
            "quantity": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_boxes_variance_order_by": {
            "price": [
                164
            ],
            "quantity": [
                164
            ],
            "volume_cm3": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_delete_at_path_input": {
            "preferred_delivery_time_windows_utc": [
                7
            ],
            "__typename": [
                7
            ]
        },
        "shipments_delete_elem_input": {
            "preferred_delivery_time_windows_utc": [
                4
            ],
            "__typename": [
                7
            ]
        },
        "shipments_delete_key_input": {
            "preferred_delivery_time_windows_utc": [
                7
            ],
            "__typename": [
                7
            ]
        },
        "shipments_inc_input": {
            "seller_discount": [
                156
            ],
            "__typename": [
                7
            ]
        },
        "shipments_max_fields": {
            "allowed_payment_methods": [
                167
            ],
            "amount_paid": [
                156
            ],
            "assigned_driver_id": [
                596
            ],
            "base_shipping_cost": [
                156
            ],
            "buyer_id": [
                596
            ],
            "company_discount": [
                156
            ],
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "delivered_timestamp": [
                578
            ],
            "destination_address_id": [
                596
            ],
            "dynamic_shipping_cost": [
                156
            ],
            "eta": [
                578
            ],
            "eta_updated": [
                578
            ],
            "id": [
                596
            ],
            "payment_status": [
                368
            ],
            "products_cost": [
                156
            ],
            "products_cost_seller": [
                156
            ],
            "ready_time": [
                578
            ],
            "required_amount": [
                156
            ],
            "returned_timestamp": [
                578
            ],
            "seller_discount": [
                156
            ],
            "seller_id": [
                596
            ],
            "seller_payout_receipt_out_id": [
                596
            ],
            "shipment_number": [
                7
            ],
            "shipping_cost": [
                156
            ],
            "status": [
                439
            ],
            "total_volume_cm3": [
                156
            ],
            "tracking_encryption_string": [
                7
            ],
            "undefined_buyer_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "shipments_max_order_by": {
            "allowed_payment_methods": [
                164
            ],
            "amount_paid": [
                164
            ],
            "assigned_driver_id": [
                164
            ],
            "base_shipping_cost": [
                164
            ],
            "buyer_id": [
                164
            ],
            "company_discount": [
                164
            ],
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "delivered_timestamp": [
                164
            ],
            "destination_address_id": [
                164
            ],
            "dynamic_shipping_cost": [
                164
            ],
            "eta": [
                164
            ],
            "eta_updated": [
                164
            ],
            "id": [
                164
            ],
            "payment_status": [
                164
            ],
            "products_cost": [
                164
            ],
            "products_cost_seller": [
                164
            ],
            "ready_time": [
                164
            ],
            "required_amount": [
                164
            ],
            "returned_timestamp": [
                164
            ],
            "seller_discount": [
                164
            ],
            "seller_id": [
                164
            ],
            "seller_payout_receipt_out_id": [
                164
            ],
            "shipment_number": [
                164
            ],
            "shipping_cost": [
                164
            ],
            "status": [
                164
            ],
            "total_volume_cm3": [
                164
            ],
            "tracking_encryption_string": [
                164
            ],
            "undefined_buyer_id": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_min_fields": {
            "allowed_payment_methods": [
                167
            ],
            "amount_paid": [
                156
            ],
            "assigned_driver_id": [
                596
            ],
            "base_shipping_cost": [
                156
            ],
            "buyer_id": [
                596
            ],
            "company_discount": [
                156
            ],
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "delivered_timestamp": [
                578
            ],
            "destination_address_id": [
                596
            ],
            "dynamic_shipping_cost": [
                156
            ],
            "eta": [
                578
            ],
            "eta_updated": [
                578
            ],
            "id": [
                596
            ],
            "payment_status": [
                368
            ],
            "products_cost": [
                156
            ],
            "products_cost_seller": [
                156
            ],
            "ready_time": [
                578
            ],
            "required_amount": [
                156
            ],
            "returned_timestamp": [
                578
            ],
            "seller_discount": [
                156
            ],
            "seller_id": [
                596
            ],
            "seller_payout_receipt_out_id": [
                596
            ],
            "shipment_number": [
                7
            ],
            "shipping_cost": [
                156
            ],
            "status": [
                439
            ],
            "total_volume_cm3": [
                156
            ],
            "tracking_encryption_string": [
                7
            ],
            "undefined_buyer_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "shipments_min_order_by": {
            "allowed_payment_methods": [
                164
            ],
            "amount_paid": [
                164
            ],
            "assigned_driver_id": [
                164
            ],
            "base_shipping_cost": [
                164
            ],
            "buyer_id": [
                164
            ],
            "company_discount": [
                164
            ],
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "delivered_timestamp": [
                164
            ],
            "destination_address_id": [
                164
            ],
            "dynamic_shipping_cost": [
                164
            ],
            "eta": [
                164
            ],
            "eta_updated": [
                164
            ],
            "id": [
                164
            ],
            "payment_status": [
                164
            ],
            "products_cost": [
                164
            ],
            "products_cost_seller": [
                164
            ],
            "ready_time": [
                164
            ],
            "required_amount": [
                164
            ],
            "returned_timestamp": [
                164
            ],
            "seller_discount": [
                164
            ],
            "seller_id": [
                164
            ],
            "seller_payout_receipt_out_id": [
                164
            ],
            "shipment_number": [
                164
            ],
            "shipping_cost": [
                164
            ],
            "status": [
                164
            ],
            "total_volume_cm3": [
                164
            ],
            "tracking_encryption_string": [
                164
            ],
            "undefined_buyer_id": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_mutation_response": {
            "affected_rows": [
                4
            ],
            "returning": [
                441
            ],
            "__typename": [
                7
            ]
        },
        "shipments_notes": {
            "Shipment": [
                441
            ],
            "created_at": [
                578
            ],
            "id": [
                596
            ],
            "note": [
                7
            ],
            "role": [
                594
            ],
            "shipment_id": [
                596
            ],
            "type": [
                366
            ],
            "user_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "shipments_notes_aggregate_order_by": {
            "count": [
                164
            ],
            "max": [
                491
            ],
            "min": [
                492
            ],
            "__typename": [
                7
            ]
        },
        "shipments_notes_bool_exp": {
            "Shipment": [
                452
            ],
            "_and": [
                490
            ],
            "_not": [
                490
            ],
            "_or": [
                490
            ],
            "created_at": [
                579
            ],
            "id": [
                598
            ],
            "note": [
                8
            ],
            "role": [
                595
            ],
            "shipment_id": [
                598
            ],
            "type": [
                367
            ],
            "user_id": [
                598
            ],
            "__typename": [
                7
            ]
        },
        "shipments_notes_max_order_by": {
            "created_at": [
                164
            ],
            "id": [
                164
            ],
            "note": [
                164
            ],
            "role": [
                164
            ],
            "shipment_id": [
                164
            ],
            "type": [
                164
            ],
            "user_id": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_notes_min_order_by": {
            "created_at": [
                164
            ],
            "id": [
                164
            ],
            "note": [
                164
            ],
            "role": [
                164
            ],
            "shipment_id": [
                164
            ],
            "type": [
                164
            ],
            "user_id": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_notes_order_by": {
            "Shipment": [
                497
            ],
            "created_at": [
                164
            ],
            "id": [
                164
            ],
            "note": [
                164
            ],
            "role": [
                164
            ],
            "shipment_id": [
                164
            ],
            "type": [
                164
            ],
            "user_id": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_notes_select_column": {},
        "shipments_notes_stream_cursor_input": {
            "initial_value": [
                496
            ],
            "ordering": [
                37
            ],
            "__typename": [
                7
            ]
        },
        "shipments_notes_stream_cursor_value_input": {
            "created_at": [
                578
            ],
            "id": [
                596
            ],
            "note": [
                7
            ],
            "role": [
                594
            ],
            "shipment_id": [
                596
            ],
            "type": [
                366
            ],
            "user_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "shipments_order_by": {
            "Assigned_driver": [
                59
            ],
            "Boxes_aggregate": [
                454
            ],
            "Buyer": [
                33
            ],
            "Destination_address": [
                21
            ],
            "Messages_aggregate": [
                107
            ],
            "Notes_aggregate": [
                489
            ],
            "Payments_aggregate": [
                499
            ],
            "Products_aggregate": [
                402
            ],
            "Routes_steps_aggregate": [
                525
            ],
            "Seller": [
                314
            ],
            "Undefined_buyer": [
                589
            ],
            "allowed_payment_methods": [
                164
            ],
            "amount_paid": [
                164
            ],
            "assigned_driver_id": [
                164
            ],
            "base_shipping_cost": [
                164
            ],
            "buyer_id": [
                164
            ],
            "cancellation_object": [
                164
            ],
            "company_discount": [
                164
            ],
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "delivered_timestamp": [
                164
            ],
            "destination_address_id": [
                164
            ],
            "dynamic_shipping_cost": [
                164
            ],
            "eta": [
                164
            ],
            "eta_updated": [
                164
            ],
            "id": [
                164
            ],
            "is_active": [
                164
            ],
            "is_company_free_shipping": [
                164
            ],
            "is_seller_free_shipping": [
                164
            ],
            "payment_status": [
                164
            ],
            "preferred_delivery_time_windows_utc": [
                164
            ],
            "products_cost": [
                164
            ],
            "products_cost_seller": [
                164
            ],
            "products_paid_in_advance": [
                164
            ],
            "ready_time": [
                164
            ],
            "required_amount": [
                164
            ],
            "returned_timestamp": [
                164
            ],
            "seller_discount": [
                164
            ],
            "seller_id": [
                164
            ],
            "seller_payout_receipt_out_id": [
                164
            ],
            "shipment_number": [
                164
            ],
            "shipping_cost": [
                164
            ],
            "status": [
                164
            ],
            "total_volume_cm3": [
                164
            ],
            "tracking_encryption_string": [
                164
            ],
            "undefined_buyer_id": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_payments": {
            "Shipment": [
                441
            ],
            "amount": [
                156
            ],
            "date_created": [
                578
            ],
            "id": [
                596
            ],
            "method": [
                167
            ],
            "notes": [
                7
            ],
            "payment_gateway": [
                165
            ],
            "payment_reference": [
                7
            ],
            "refunds_payment_id": [
                596
            ],
            "shipment_id": [
                596
            ],
            "status": [
                170
            ],
            "transaction_type": [
                580
            ],
            "__typename": [
                7
            ]
        },
        "shipments_payments_aggregate_order_by": {
            "avg": [
                500
            ],
            "count": [
                164
            ],
            "max": [
                502
            ],
            "min": [
                503
            ],
            "stddev": [
                506
            ],
            "stddev_pop": [
                507
            ],
            "stddev_samp": [
                508
            ],
            "sum": [
                511
            ],
            "var_pop": [
                512
            ],
            "var_samp": [
                513
            ],
            "variance": [
                514
            ],
            "__typename": [
                7
            ]
        },
        "shipments_payments_avg_order_by": {
            "amount": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_payments_bool_exp": {
            "Shipment": [
                452
            ],
            "_and": [
                501
            ],
            "_not": [
                501
            ],
            "_or": [
                501
            ],
            "amount": [
                157
            ],
            "date_created": [
                579
            ],
            "id": [
                598
            ],
            "method": [
                169
            ],
            "notes": [
                8
            ],
            "payment_gateway": [
                166
            ],
            "payment_reference": [
                8
            ],
            "refunds_payment_id": [
                598
            ],
            "shipment_id": [
                598
            ],
            "status": [
                171
            ],
            "transaction_type": [
                581
            ],
            "__typename": [
                7
            ]
        },
        "shipments_payments_max_order_by": {
            "amount": [
                164
            ],
            "date_created": [
                164
            ],
            "id": [
                164
            ],
            "method": [
                164
            ],
            "notes": [
                164
            ],
            "payment_gateway": [
                164
            ],
            "payment_reference": [
                164
            ],
            "refunds_payment_id": [
                164
            ],
            "shipment_id": [
                164
            ],
            "status": [
                164
            ],
            "transaction_type": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_payments_min_order_by": {
            "amount": [
                164
            ],
            "date_created": [
                164
            ],
            "id": [
                164
            ],
            "method": [
                164
            ],
            "notes": [
                164
            ],
            "payment_gateway": [
                164
            ],
            "payment_reference": [
                164
            ],
            "refunds_payment_id": [
                164
            ],
            "shipment_id": [
                164
            ],
            "status": [
                164
            ],
            "transaction_type": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_payments_order_by": {
            "Shipment": [
                497
            ],
            "amount": [
                164
            ],
            "date_created": [
                164
            ],
            "id": [
                164
            ],
            "method": [
                164
            ],
            "notes": [
                164
            ],
            "payment_gateway": [
                164
            ],
            "payment_reference": [
                164
            ],
            "refunds_payment_id": [
                164
            ],
            "shipment_id": [
                164
            ],
            "status": [
                164
            ],
            "transaction_type": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_payments_select_column": {},
        "shipments_payments_stddev_order_by": {
            "amount": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_payments_stddev_pop_order_by": {
            "amount": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_payments_stddev_samp_order_by": {
            "amount": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_payments_stream_cursor_input": {
            "initial_value": [
                510
            ],
            "ordering": [
                37
            ],
            "__typename": [
                7
            ]
        },
        "shipments_payments_stream_cursor_value_input": {
            "amount": [
                156
            ],
            "date_created": [
                578
            ],
            "id": [
                596
            ],
            "method": [
                167
            ],
            "notes": [
                7
            ],
            "payment_gateway": [
                165
            ],
            "payment_reference": [
                7
            ],
            "refunds_payment_id": [
                596
            ],
            "shipment_id": [
                596
            ],
            "status": [
                170
            ],
            "transaction_type": [
                580
            ],
            "__typename": [
                7
            ]
        },
        "shipments_payments_sum_order_by": {
            "amount": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_payments_var_pop_order_by": {
            "amount": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_payments_var_samp_order_by": {
            "amount": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_payments_variance_order_by": {
            "amount": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_pk_columns_input": {
            "id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "shipments_prepend_input": {
            "preferred_delivery_time_windows_utc": [
                99
            ],
            "__typename": [
                7
            ]
        },
        "shipments_routes_steps": {
            "Address": [
                11
            ],
            "Shipments": [
                524,
                {
                    "distinct_on": [
                        531,
                        "[shipments_routes_steps_shipments_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        530,
                        "[shipments_routes_steps_shipments_order_by!]"
                    ],
                    "where": [
                        527
                    ]
                }
            ],
            "address_id": [
                596
            ],
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "eta": [
                578
            ],
            "id": [
                596
            ],
            "status": [
                246
            ],
            "type": [
                574
            ],
            "__typename": [
                7
            ]
        },
        "shipments_routes_steps_aggregate_order_by": {
            "count": [
                164
            ],
            "max": [
                520
            ],
            "min": [
                521
            ],
            "__typename": [
                7
            ]
        },
        "shipments_routes_steps_bool_exp": {
            "Address": [
                14
            ],
            "Shipments": [
                527
            ],
            "_and": [
                519
            ],
            "_not": [
                519
            ],
            "_or": [
                519
            ],
            "address_id": [
                598
            ],
            "date_created": [
                579
            ],
            "date_updated": [
                579
            ],
            "eta": [
                579
            ],
            "id": [
                598
            ],
            "status": [
                247
            ],
            "type": [
                575
            ],
            "__typename": [
                7
            ]
        },
        "shipments_routes_steps_max_order_by": {
            "address_id": [
                164
            ],
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "eta": [
                164
            ],
            "id": [
                164
            ],
            "status": [
                164
            ],
            "type": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_routes_steps_min_order_by": {
            "address_id": [
                164
            ],
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "eta": [
                164
            ],
            "id": [
                164
            ],
            "status": [
                164
            ],
            "type": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_routes_steps_order_by": {
            "Address": [
                21
            ],
            "Shipments_aggregate": [
                525
            ],
            "address_id": [
                164
            ],
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "eta": [
                164
            ],
            "id": [
                164
            ],
            "status": [
                164
            ],
            "type": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_routes_steps_select_column": {},
        "shipments_routes_steps_shipments": {
            "Route_step": [
                517
            ],
            "Shipment": [
                441
            ],
            "completion_timestamp": [
                578
            ],
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "id": [
                596
            ],
            "is_completed": [
                0
            ],
            "is_noshow": [
                0
            ],
            "is_reschedule": [
                0
            ],
            "shipment_id": [
                596
            ],
            "shipments_routes_step_id": [
                596
            ],
            "shipping_cost": [
                156
            ],
            "type": [
                574
            ],
            "__typename": [
                7
            ]
        },
        "shipments_routes_steps_shipments_aggregate_order_by": {
            "avg": [
                526
            ],
            "count": [
                164
            ],
            "max": [
                528
            ],
            "min": [
                529
            ],
            "stddev": [
                532
            ],
            "stddev_pop": [
                533
            ],
            "stddev_samp": [
                534
            ],
            "sum": [
                537
            ],
            "var_pop": [
                538
            ],
            "var_samp": [
                539
            ],
            "variance": [
                540
            ],
            "__typename": [
                7
            ]
        },
        "shipments_routes_steps_shipments_avg_order_by": {
            "shipping_cost": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_routes_steps_shipments_bool_exp": {
            "Route_step": [
                519
            ],
            "Shipment": [
                452
            ],
            "_and": [
                527
            ],
            "_not": [
                527
            ],
            "_or": [
                527
            ],
            "completion_timestamp": [
                579
            ],
            "date_created": [
                579
            ],
            "date_updated": [
                579
            ],
            "id": [
                598
            ],
            "is_completed": [
                1
            ],
            "is_noshow": [
                1
            ],
            "is_reschedule": [
                1
            ],
            "shipment_id": [
                598
            ],
            "shipments_routes_step_id": [
                598
            ],
            "shipping_cost": [
                157
            ],
            "type": [
                575
            ],
            "__typename": [
                7
            ]
        },
        "shipments_routes_steps_shipments_max_order_by": {
            "completion_timestamp": [
                164
            ],
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "id": [
                164
            ],
            "shipment_id": [
                164
            ],
            "shipments_routes_step_id": [
                164
            ],
            "shipping_cost": [
                164
            ],
            "type": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_routes_steps_shipments_min_order_by": {
            "completion_timestamp": [
                164
            ],
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "id": [
                164
            ],
            "shipment_id": [
                164
            ],
            "shipments_routes_step_id": [
                164
            ],
            "shipping_cost": [
                164
            ],
            "type": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_routes_steps_shipments_order_by": {
            "Route_step": [
                522
            ],
            "Shipment": [
                497
            ],
            "completion_timestamp": [
                164
            ],
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "id": [
                164
            ],
            "is_completed": [
                164
            ],
            "is_noshow": [
                164
            ],
            "is_reschedule": [
                164
            ],
            "shipment_id": [
                164
            ],
            "shipments_routes_step_id": [
                164
            ],
            "shipping_cost": [
                164
            ],
            "type": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_routes_steps_shipments_select_column": {},
        "shipments_routes_steps_shipments_stddev_order_by": {
            "shipping_cost": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_routes_steps_shipments_stddev_pop_order_by": {
            "shipping_cost": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_routes_steps_shipments_stddev_samp_order_by": {
            "shipping_cost": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_routes_steps_shipments_stream_cursor_input": {
            "initial_value": [
                536
            ],
            "ordering": [
                37
            ],
            "__typename": [
                7
            ]
        },
        "shipments_routes_steps_shipments_stream_cursor_value_input": {
            "completion_timestamp": [
                578
            ],
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "id": [
                596
            ],
            "is_completed": [
                0
            ],
            "is_noshow": [
                0
            ],
            "is_reschedule": [
                0
            ],
            "shipment_id": [
                596
            ],
            "shipments_routes_step_id": [
                596
            ],
            "shipping_cost": [
                156
            ],
            "type": [
                574
            ],
            "__typename": [
                7
            ]
        },
        "shipments_routes_steps_shipments_sum_order_by": {
            "shipping_cost": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_routes_steps_shipments_var_pop_order_by": {
            "shipping_cost": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_routes_steps_shipments_var_samp_order_by": {
            "shipping_cost": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_routes_steps_shipments_variance_order_by": {
            "shipping_cost": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_routes_steps_stream_cursor_input": {
            "initial_value": [
                542
            ],
            "ordering": [
                37
            ],
            "__typename": [
                7
            ]
        },
        "shipments_routes_steps_stream_cursor_value_input": {
            "address_id": [
                596
            ],
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "eta": [
                578
            ],
            "id": [
                596
            ],
            "status": [
                246
            ],
            "type": [
                574
            ],
            "__typename": [
                7
            ]
        },
        "shipments_select_column": {},
        "shipments_select_column_shipments_aggregate_bool_exp_bool_and_arguments_columns": {},
        "shipments_select_column_shipments_aggregate_bool_exp_bool_or_arguments_columns": {},
        "shipments_set_input": {
            "allowed_payment_methods": [
                167
            ],
            "destination_address_id": [
                596
            ],
            "is_seller_free_shipping": [
                0
            ],
            "preferred_delivery_time_windows_utc": [
                99
            ],
            "products_paid_in_advance": [
                0
            ],
            "ready_time": [
                578
            ],
            "seller_discount": [
                156
            ],
            "__typename": [
                7
            ]
        },
        "shipments_stddev_fields": {
            "amount_paid": [
                2
            ],
            "base_shipping_cost": [
                2
            ],
            "company_discount": [
                2
            ],
            "dynamic_shipping_cost": [
                2
            ],
            "products_cost": [
                2
            ],
            "products_cost_seller": [
                2
            ],
            "required_amount": [
                2
            ],
            "seller_discount": [
                2
            ],
            "shipping_cost": [
                2
            ],
            "total_volume_cm3": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "shipments_stddev_order_by": {
            "amount_paid": [
                164
            ],
            "base_shipping_cost": [
                164
            ],
            "company_discount": [
                164
            ],
            "dynamic_shipping_cost": [
                164
            ],
            "products_cost": [
                164
            ],
            "products_cost_seller": [
                164
            ],
            "required_amount": [
                164
            ],
            "seller_discount": [
                164
            ],
            "shipping_cost": [
                164
            ],
            "total_volume_cm3": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_stddev_pop_fields": {
            "amount_paid": [
                2
            ],
            "base_shipping_cost": [
                2
            ],
            "company_discount": [
                2
            ],
            "dynamic_shipping_cost": [
                2
            ],
            "products_cost": [
                2
            ],
            "products_cost_seller": [
                2
            ],
            "required_amount": [
                2
            ],
            "seller_discount": [
                2
            ],
            "shipping_cost": [
                2
            ],
            "total_volume_cm3": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "shipments_stddev_pop_order_by": {
            "amount_paid": [
                164
            ],
            "base_shipping_cost": [
                164
            ],
            "company_discount": [
                164
            ],
            "dynamic_shipping_cost": [
                164
            ],
            "products_cost": [
                164
            ],
            "products_cost_seller": [
                164
            ],
            "required_amount": [
                164
            ],
            "seller_discount": [
                164
            ],
            "shipping_cost": [
                164
            ],
            "total_volume_cm3": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_stddev_samp_fields": {
            "amount_paid": [
                2
            ],
            "base_shipping_cost": [
                2
            ],
            "company_discount": [
                2
            ],
            "dynamic_shipping_cost": [
                2
            ],
            "products_cost": [
                2
            ],
            "products_cost_seller": [
                2
            ],
            "required_amount": [
                2
            ],
            "seller_discount": [
                2
            ],
            "shipping_cost": [
                2
            ],
            "total_volume_cm3": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "shipments_stddev_samp_order_by": {
            "amount_paid": [
                164
            ],
            "base_shipping_cost": [
                164
            ],
            "company_discount": [
                164
            ],
            "dynamic_shipping_cost": [
                164
            ],
            "products_cost": [
                164
            ],
            "products_cost_seller": [
                164
            ],
            "required_amount": [
                164
            ],
            "seller_discount": [
                164
            ],
            "shipping_cost": [
                164
            ],
            "total_volume_cm3": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_stream_cursor_input": {
            "initial_value": [
                554
            ],
            "ordering": [
                37
            ],
            "__typename": [
                7
            ]
        },
        "shipments_stream_cursor_value_input": {
            "allowed_payment_methods": [
                167
            ],
            "amount_paid": [
                156
            ],
            "assigned_driver_id": [
                596
            ],
            "base_shipping_cost": [
                156
            ],
            "buyer_id": [
                596
            ],
            "cancellation_object": [
                99
            ],
            "company_discount": [
                156
            ],
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "delivered_timestamp": [
                578
            ],
            "destination_address_id": [
                596
            ],
            "dynamic_shipping_cost": [
                156
            ],
            "eta": [
                578
            ],
            "eta_updated": [
                578
            ],
            "id": [
                596
            ],
            "is_active": [
                0
            ],
            "is_company_free_shipping": [
                0
            ],
            "is_seller_free_shipping": [
                0
            ],
            "payment_status": [
                368
            ],
            "preferred_delivery_time_windows_utc": [
                99
            ],
            "products_cost": [
                156
            ],
            "products_cost_seller": [
                156
            ],
            "products_paid_in_advance": [
                0
            ],
            "ready_time": [
                578
            ],
            "required_amount": [
                156
            ],
            "returned_timestamp": [
                578
            ],
            "seller_discount": [
                156
            ],
            "seller_id": [
                596
            ],
            "seller_payout_receipt_out_id": [
                596
            ],
            "shipment_number": [
                7
            ],
            "shipping_cost": [
                156
            ],
            "status": [
                439
            ],
            "total_volume_cm3": [
                156
            ],
            "tracking_encryption_string": [
                7
            ],
            "undefined_buyer_id": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "shipments_sum_fields": {
            "amount_paid": [
                156
            ],
            "base_shipping_cost": [
                156
            ],
            "company_discount": [
                156
            ],
            "dynamic_shipping_cost": [
                156
            ],
            "products_cost": [
                156
            ],
            "products_cost_seller": [
                156
            ],
            "required_amount": [
                156
            ],
            "seller_discount": [
                156
            ],
            "shipping_cost": [
                156
            ],
            "total_volume_cm3": [
                156
            ],
            "__typename": [
                7
            ]
        },
        "shipments_sum_order_by": {
            "amount_paid": [
                164
            ],
            "base_shipping_cost": [
                164
            ],
            "company_discount": [
                164
            ],
            "dynamic_shipping_cost": [
                164
            ],
            "products_cost": [
                164
            ],
            "products_cost_seller": [
                164
            ],
            "required_amount": [
                164
            ],
            "seller_discount": [
                164
            ],
            "shipping_cost": [
                164
            ],
            "total_volume_cm3": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_updates": {
            "_append": [
                449
            ],
            "_delete_at_path": [
                479
            ],
            "_delete_elem": [
                480
            ],
            "_delete_key": [
                481
            ],
            "_inc": [
                482
            ],
            "_prepend": [
                516
            ],
            "_set": [
                546
            ],
            "where": [
                452
            ],
            "__typename": [
                7
            ]
        },
        "shipments_var_pop_fields": {
            "amount_paid": [
                2
            ],
            "base_shipping_cost": [
                2
            ],
            "company_discount": [
                2
            ],
            "dynamic_shipping_cost": [
                2
            ],
            "products_cost": [
                2
            ],
            "products_cost_seller": [
                2
            ],
            "required_amount": [
                2
            ],
            "seller_discount": [
                2
            ],
            "shipping_cost": [
                2
            ],
            "total_volume_cm3": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "shipments_var_pop_order_by": {
            "amount_paid": [
                164
            ],
            "base_shipping_cost": [
                164
            ],
            "company_discount": [
                164
            ],
            "dynamic_shipping_cost": [
                164
            ],
            "products_cost": [
                164
            ],
            "products_cost_seller": [
                164
            ],
            "required_amount": [
                164
            ],
            "seller_discount": [
                164
            ],
            "shipping_cost": [
                164
            ],
            "total_volume_cm3": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_var_samp_fields": {
            "amount_paid": [
                2
            ],
            "base_shipping_cost": [
                2
            ],
            "company_discount": [
                2
            ],
            "dynamic_shipping_cost": [
                2
            ],
            "products_cost": [
                2
            ],
            "products_cost_seller": [
                2
            ],
            "required_amount": [
                2
            ],
            "seller_discount": [
                2
            ],
            "shipping_cost": [
                2
            ],
            "total_volume_cm3": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "shipments_var_samp_order_by": {
            "amount_paid": [
                164
            ],
            "base_shipping_cost": [
                164
            ],
            "company_discount": [
                164
            ],
            "dynamic_shipping_cost": [
                164
            ],
            "products_cost": [
                164
            ],
            "products_cost_seller": [
                164
            ],
            "required_amount": [
                164
            ],
            "seller_discount": [
                164
            ],
            "shipping_cost": [
                164
            ],
            "total_volume_cm3": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipments_variance_fields": {
            "amount_paid": [
                2
            ],
            "base_shipping_cost": [
                2
            ],
            "company_discount": [
                2
            ],
            "dynamic_shipping_cost": [
                2
            ],
            "products_cost": [
                2
            ],
            "products_cost_seller": [
                2
            ],
            "required_amount": [
                2
            ],
            "seller_discount": [
                2
            ],
            "shipping_cost": [
                2
            ],
            "total_volume_cm3": [
                2
            ],
            "__typename": [
                7
            ]
        },
        "shipments_variance_order_by": {
            "amount_paid": [
                164
            ],
            "base_shipping_cost": [
                164
            ],
            "company_discount": [
                164
            ],
            "dynamic_shipping_cost": [
                164
            ],
            "products_cost": [
                164
            ],
            "products_cost_seller": [
                164
            ],
            "required_amount": [
                164
            ],
            "seller_discount": [
                164
            ],
            "shipping_cost": [
                164
            ],
            "total_volume_cm3": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipping_city": {},
        "shipping_city_comparison_exp": {
            "_eq": [
                564
            ],
            "_gt": [
                564
            ],
            "_gte": [
                564
            ],
            "_in": [
                564
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                564
            ],
            "_lte": [
                564
            ],
            "_neq": [
                564
            ],
            "_nin": [
                564
            ],
            "__typename": [
                7
            ]
        },
        "shipping_cost_per_city": {
            "Addresses": [
                11,
                {
                    "distinct_on": [
                        23,
                        "[addresses_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        21,
                        "[addresses_order_by!]"
                    ],
                    "where": [
                        14
                    ]
                }
            ],
            "base_cost": [
                156
            ],
            "city": [
                564
            ],
            "cm3_multiplier": [
                156
            ],
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "geo_fence": [
                99,
                {
                    "path": [
                        7
                    ]
                }
            ],
            "id": [
                596
            ],
            "minimum_cost": [
                156
            ],
            "__typename": [
                7
            ]
        },
        "shipping_cost_per_city_bool_exp": {
            "Addresses": [
                14
            ],
            "_and": [
                567
            ],
            "_not": [
                567
            ],
            "_or": [
                567
            ],
            "base_cost": [
                157
            ],
            "city": [
                565
            ],
            "cm3_multiplier": [
                157
            ],
            "date_created": [
                579
            ],
            "date_updated": [
                579
            ],
            "geo_fence": [
                101
            ],
            "id": [
                598
            ],
            "minimum_cost": [
                157
            ],
            "__typename": [
                7
            ]
        },
        "shipping_cost_per_city_order_by": {
            "Addresses_aggregate": [
                12
            ],
            "base_cost": [
                164
            ],
            "city": [
                164
            ],
            "cm3_multiplier": [
                164
            ],
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "geo_fence": [
                164
            ],
            "id": [
                164
            ],
            "minimum_cost": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "shipping_cost_per_city_select_column": {},
        "shipping_cost_per_city_stream_cursor_input": {
            "initial_value": [
                571
            ],
            "ordering": [
                37
            ],
            "__typename": [
                7
            ]
        },
        "shipping_cost_per_city_stream_cursor_value_input": {
            "base_cost": [
                156
            ],
            "city": [
                564
            ],
            "cm3_multiplier": [
                156
            ],
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "geo_fence": [
                99
            ],
            "id": [
                596
            ],
            "minimum_cost": [
                156
            ],
            "__typename": [
                7
            ]
        },
        "st_d_within_geography_input": {
            "distance": [
                2
            ],
            "from": [
                93
            ],
            "use_spheroid": [
                0
            ],
            "__typename": [
                7
            ]
        },
        "st_d_within_input": {
            "distance": [
                2
            ],
            "from": [
                96
            ],
            "__typename": [
                7
            ]
        },
        "step_type": {},
        "step_type_comparison_exp": {
            "_eq": [
                574
            ],
            "_gt": [
                574
            ],
            "_gte": [
                574
            ],
            "_in": [
                574
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                574
            ],
            "_lte": [
                574
            ],
            "_neq": [
                574
            ],
            "_nin": [
                574
            ],
            "__typename": [
                7
            ]
        },
        "timestamp": {},
        "timestamp_comparison_exp": {
            "_eq": [
                576
            ],
            "_gt": [
                576
            ],
            "_gte": [
                576
            ],
            "_in": [
                576
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                576
            ],
            "_lte": [
                576
            ],
            "_neq": [
                576
            ],
            "_nin": [
                576
            ],
            "__typename": [
                7
            ]
        },
        "timestamptz": {},
        "timestamptz_comparison_exp": {
            "_eq": [
                578
            ],
            "_gt": [
                578
            ],
            "_gte": [
                578
            ],
            "_in": [
                578
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                578
            ],
            "_lte": [
                578
            ],
            "_neq": [
                578
            ],
            "_nin": [
                578
            ],
            "__typename": [
                7
            ]
        },
        "transaction_type": {},
        "transaction_type_comparison_exp": {
            "_eq": [
                580
            ],
            "_gt": [
                580
            ],
            "_gte": [
                580
            ],
            "_in": [
                580
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                580
            ],
            "_lte": [
                580
            ],
            "_neq": [
                580
            ],
            "_nin": [
                580
            ],
            "__typename": [
                7
            ]
        },
        "undefined_buyers": {
            "Addresses": [
                11,
                {
                    "distinct_on": [
                        23,
                        "[addresses_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        21,
                        "[addresses_order_by!]"
                    ],
                    "where": [
                        14
                    ]
                }
            ],
            "Shipments": [
                441,
                {
                    "distinct_on": [
                        543,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        497,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        452
                    ]
                }
            ],
            "Shipments_aggregate": [
                442,
                {
                    "distinct_on": [
                        543,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        497,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        452
                    ]
                }
            ],
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "has_whatsapp": [
                0
            ],
            "id": [
                596
            ],
            "name": [
                7
            ],
            "phone_number": [
                7
            ],
            "__typename": [
                7
            ]
        },
        "undefined_buyers_bool_exp": {
            "Addresses": [
                14
            ],
            "Shipments": [
                452
            ],
            "Shipments_aggregate": [
                443
            ],
            "_and": [
                583
            ],
            "_not": [
                583
            ],
            "_or": [
                583
            ],
            "date_created": [
                579
            ],
            "date_updated": [
                579
            ],
            "has_whatsapp": [
                1
            ],
            "id": [
                598
            ],
            "name": [
                8
            ],
            "phone_number": [
                8
            ],
            "__typename": [
                7
            ]
        },
        "undefined_buyers_constraint": {},
        "undefined_buyers_insert_input": {
            "Addresses": [
                13
            ],
            "name": [
                7
            ],
            "phone_number": [
                7
            ],
            "__typename": [
                7
            ]
        },
        "undefined_buyers_mutation_response": {
            "affected_rows": [
                4
            ],
            "returning": [
                582
            ],
            "__typename": [
                7
            ]
        },
        "undefined_buyers_obj_rel_insert_input": {
            "data": [
                585
            ],
            "on_conflict": [
                588
            ],
            "__typename": [
                7
            ]
        },
        "undefined_buyers_on_conflict": {
            "constraint": [
                584
            ],
            "update_columns": [
                593
            ],
            "where": [
                583
            ],
            "__typename": [
                7
            ]
        },
        "undefined_buyers_order_by": {
            "Addresses_aggregate": [
                12
            ],
            "Shipments_aggregate": [
                448
            ],
            "date_created": [
                164
            ],
            "date_updated": [
                164
            ],
            "has_whatsapp": [
                164
            ],
            "id": [
                164
            ],
            "name": [
                164
            ],
            "phone_number": [
                164
            ],
            "__typename": [
                7
            ]
        },
        "undefined_buyers_select_column": {},
        "undefined_buyers_stream_cursor_input": {
            "initial_value": [
                592
            ],
            "ordering": [
                37
            ],
            "__typename": [
                7
            ]
        },
        "undefined_buyers_stream_cursor_value_input": {
            "date_created": [
                578
            ],
            "date_updated": [
                578
            ],
            "has_whatsapp": [
                0
            ],
            "id": [
                596
            ],
            "name": [
                7
            ],
            "phone_number": [
                7
            ],
            "__typename": [
                7
            ]
        },
        "undefined_buyers_update_column": {},
        "user_role": {},
        "user_role_comparison_exp": {
            "_eq": [
                594
            ],
            "_gt": [
                594
            ],
            "_gte": [
                594
            ],
            "_in": [
                594
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                594
            ],
            "_lte": [
                594
            ],
            "_neq": [
                594
            ],
            "_nin": [
                594
            ],
            "__typename": [
                7
            ]
        },
        "uuid": {},
        "uuid_array_comparison_exp": {
            "_contained_in": [
                596
            ],
            "_contains": [
                596
            ],
            "_eq": [
                596
            ],
            "_gt": [
                596
            ],
            "_gte": [
                596
            ],
            "_in": [
                596
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                596
            ],
            "_lte": [
                596
            ],
            "_neq": [
                596
            ],
            "_nin": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "uuid_comparison_exp": {
            "_eq": [
                596
            ],
            "_gt": [
                596
            ],
            "_gte": [
                596
            ],
            "_in": [
                596
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                596
            ],
            "_lte": [
                596
            ],
            "_neq": [
                596
            ],
            "_nin": [
                596
            ],
            "__typename": [
                7
            ]
        },
        "Query": {
            "addresses": [
                11,
                {
                    "distinct_on": [
                        23,
                        "[addresses_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        21,
                        "[addresses_order_by!]"
                    ],
                    "where": [
                        14
                    ]
                }
            ],
            "addresses_by_pk": [
                11,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "buyers": [
                31,
                {
                    "distinct_on": [
                        34,
                        "[buyers_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        33,
                        "[buyers_order_by!]"
                    ],
                    "where": [
                        32
                    ]
                }
            ],
            "buyers_by_pk": [
                31,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "drivers": [
                40,
                {
                    "distinct_on": [
                        60,
                        "[drivers_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        59,
                        "[drivers_order_by!]"
                    ],
                    "where": [
                        41
                    ]
                }
            ],
            "drivers_by_pk": [
                40,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "drivers_locations": [
                42,
                {
                    "distinct_on": [
                        49,
                        "[drivers_locations_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        48,
                        "[drivers_locations_order_by!]"
                    ],
                    "where": [
                        45
                    ]
                }
            ],
            "drivers_locations_by_pk": [
                42,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "env_variables": [
                65,
                {
                    "distinct_on": [
                        68,
                        "[env_variables_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        67,
                        "[env_variables_order_by!]"
                    ],
                    "where": [
                        66
                    ]
                }
            ],
            "env_variables_by_pk": [
                65,
                {
                    "key": [
                        7,
                        "String!"
                    ]
                }
            ],
            "food_categories": [
                73,
                {
                    "distinct_on": [
                        90,
                        "[food_categories_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        75,
                        "[food_categories_order_by!]"
                    ],
                    "where": [
                        74
                    ]
                }
            ],
            "food_categories_by_pk": [
                73,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "food_categories_products": [
                76,
                {
                    "distinct_on": [
                        86,
                        "[food_categories_products_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        85,
                        "[food_categories_products_order_by!]"
                    ],
                    "where": [
                        78
                    ]
                }
            ],
            "food_categories_products_by_pk": [
                76,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "messages": [
                102,
                {
                    "distinct_on": [
                        135,
                        "[messages_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        133,
                        "[messages_order_by!]"
                    ],
                    "where": [
                        108
                    ]
                }
            ],
            "messages_aggregate": [
                103,
                {
                    "distinct_on": [
                        135,
                        "[messages_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        133,
                        "[messages_order_by!]"
                    ],
                    "where": [
                        108
                    ]
                }
            ],
            "messages_by_pk": [
                102,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "messages_from": [
                110,
                {
                    "distinct_on": [
                        121,
                        "[messages_from_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        120,
                        "[messages_from_order_by!]"
                    ],
                    "where": [
                        112
                    ]
                }
            ],
            "messages_from_by_pk": [
                110,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "messages_to": [
                139,
                {
                    "distinct_on": [
                        150,
                        "[messages_to_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        149,
                        "[messages_to_order_by!]"
                    ],
                    "where": [
                        141
                    ]
                }
            ],
            "messages_to_by_pk": [
                139,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "operators": [
                158,
                {
                    "distinct_on": [
                        161,
                        "[operators_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        160,
                        "[operators_order_by!]"
                    ],
                    "where": [
                        159
                    ]
                }
            ],
            "operators_by_pk": [
                158,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "products": [
                172,
                {
                    "distinct_on": [
                        224,
                        "[products_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        222,
                        "[products_order_by!]"
                    ],
                    "where": [
                        183
                    ]
                }
            ],
            "products_aggregate": [
                173,
                {
                    "distinct_on": [
                        224,
                        "[products_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        222,
                        "[products_order_by!]"
                    ],
                    "where": [
                        183
                    ]
                }
            ],
            "products_by_pk": [
                172,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "products_extras": [
                185,
                {
                    "distinct_on": [
                        200,
                        "[products_extras_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        198,
                        "[products_extras_order_by!]"
                    ],
                    "where": [
                        189
                    ]
                }
            ],
            "products_extras_by_pk": [
                185,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "seller_products_standard_sizes": [
                248,
                {
                    "distinct_on": [
                        260,
                        "[seller_products_standard_sizes_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        259,
                        "[seller_products_standard_sizes_order_by!]"
                    ],
                    "where": [
                        251
                    ]
                }
            ],
            "seller_products_standard_sizes_by_pk": [
                248,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "seller_reviews": [
                271,
                {
                    "distinct_on": [
                        287,
                        "[seller_reviews_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        285,
                        "[seller_reviews_order_by!]"
                    ],
                    "where": [
                        279
                    ]
                }
            ],
            "seller_reviews_aggregate": [
                272,
                {
                    "distinct_on": [
                        287,
                        "[seller_reviews_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        285,
                        "[seller_reviews_order_by!]"
                    ],
                    "where": [
                        279
                    ]
                }
            ],
            "seller_reviews_by_pk": [
                271,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "sellers": [
                306,
                {
                    "distinct_on": [
                        348,
                        "[sellers_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        314,
                        "[sellers_order_by!]"
                    ],
                    "where": [
                        308
                    ]
                }
            ],
            "sellers_by_pk": [
                306,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "sellers_payouts_receipts_out": [
                315,
                {
                    "distinct_on": [
                        329,
                        "[sellers_payouts_receipts_out_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        328,
                        "[sellers_payouts_receipts_out_order_by!]"
                    ],
                    "where": [
                        323
                    ]
                }
            ],
            "sellers_payouts_receipts_out_aggregate": [
                316,
                {
                    "distinct_on": [
                        329,
                        "[sellers_payouts_receipts_out_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        328,
                        "[sellers_payouts_receipts_out_order_by!]"
                    ],
                    "where": [
                        323
                    ]
                }
            ],
            "sellers_payouts_receipts_out_by_pk": [
                315,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "sellers_users": [
                353,
                {
                    "distinct_on": [
                        361,
                        "[sellers_users_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        359,
                        "[sellers_users_order_by!]"
                    ],
                    "where": [
                        355
                    ]
                }
            ],
            "sellers_users_by_pk": [
                353,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "shipment_product_item_extras": [
                370,
                {
                    "distinct_on": [
                        384,
                        "[shipment_product_item_extras_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        382,
                        "[shipment_product_item_extras_order_by!]"
                    ],
                    "where": [
                        374
                    ]
                }
            ],
            "shipment_product_item_extras_by_pk": [
                370,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "shipment_products_items": [
                397,
                {
                    "distinct_on": [
                        419,
                        "[shipment_products_items_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        417,
                        "[shipment_products_items_order_by!]"
                    ],
                    "where": [
                        406
                    ]
                }
            ],
            "shipment_products_items_aggregate": [
                398,
                {
                    "distinct_on": [
                        419,
                        "[shipment_products_items_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        417,
                        "[shipment_products_items_order_by!]"
                    ],
                    "where": [
                        406
                    ]
                }
            ],
            "shipment_products_items_by_pk": [
                397,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "shipments": [
                441,
                {
                    "distinct_on": [
                        543,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        497,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        452
                    ]
                }
            ],
            "shipments_aggregate": [
                442,
                {
                    "distinct_on": [
                        543,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        497,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        452
                    ]
                }
            ],
            "shipments_boxes": [
                453,
                {
                    "distinct_on": [
                        466,
                        "[shipments_boxes_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        464,
                        "[shipments_boxes_order_by!]"
                    ],
                    "where": [
                        456
                    ]
                }
            ],
            "shipments_boxes_by_pk": [
                453,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "shipments_by_pk": [
                441,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "shipments_notes": [
                488,
                {
                    "distinct_on": [
                        494,
                        "[shipments_notes_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        493,
                        "[shipments_notes_order_by!]"
                    ],
                    "where": [
                        490
                    ]
                }
            ],
            "shipments_payments": [
                498,
                {
                    "distinct_on": [
                        505,
                        "[shipments_payments_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        504,
                        "[shipments_payments_order_by!]"
                    ],
                    "where": [
                        501
                    ]
                }
            ],
            "shipments_payments_by_pk": [
                498,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "shipments_routes_steps": [
                517,
                {
                    "distinct_on": [
                        523,
                        "[shipments_routes_steps_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        522,
                        "[shipments_routes_steps_order_by!]"
                    ],
                    "where": [
                        519
                    ]
                }
            ],
            "shipments_routes_steps_by_pk": [
                517,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "shipments_routes_steps_shipments": [
                524,
                {
                    "distinct_on": [
                        531,
                        "[shipments_routes_steps_shipments_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        530,
                        "[shipments_routes_steps_shipments_order_by!]"
                    ],
                    "where": [
                        527
                    ]
                }
            ],
            "shipments_routes_steps_shipments_by_pk": [
                524,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "shipping_cost_per_city": [
                566,
                {
                    "distinct_on": [
                        569,
                        "[shipping_cost_per_city_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        568,
                        "[shipping_cost_per_city_order_by!]"
                    ],
                    "where": [
                        567
                    ]
                }
            ],
            "shipping_cost_per_city_by_pk": [
                566,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "undefined_buyers": [
                582,
                {
                    "distinct_on": [
                        590,
                        "[undefined_buyers_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        589,
                        "[undefined_buyers_order_by!]"
                    ],
                    "where": [
                        583
                    ]
                }
            ],
            "undefined_buyers_by_pk": [
                582,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "__typename": [
                7
            ]
        },
        "Mutation": {
            "extract_coordinates_from_url": [
                3,
                {
                    "url": [
                        7,
                        "String!"
                    ]
                }
            ],
            "insert_addresses": [
                19,
                {
                    "objects": [
                        16,
                        "[addresses_insert_input!]!"
                    ],
                    "on_conflict": [
                        20
                    ]
                }
            ],
            "insert_addresses_one": [
                11,
                {
                    "object": [
                        16,
                        "addresses_insert_input!"
                    ],
                    "on_conflict": [
                        20
                    ]
                }
            ],
            "insert_food_categories_products": [
                83,
                {
                    "objects": [
                        80,
                        "[food_categories_products_insert_input!]!"
                    ],
                    "on_conflict": [
                        84
                    ]
                }
            ],
            "insert_food_categories_products_one": [
                76,
                {
                    "object": [
                        80,
                        "food_categories_products_insert_input!"
                    ],
                    "on_conflict": [
                        84
                    ]
                }
            ],
            "insert_messages": [
                130,
                {
                    "objects": [
                        125,
                        "[messages_insert_input!]!"
                    ],
                    "on_conflict": [
                        132
                    ]
                }
            ],
            "insert_messages_from": [
                117,
                {
                    "objects": [
                        114,
                        "[messages_from_insert_input!]!"
                    ],
                    "on_conflict": [
                        119
                    ]
                }
            ],
            "insert_messages_from_one": [
                110,
                {
                    "object": [
                        114,
                        "messages_from_insert_input!"
                    ],
                    "on_conflict": [
                        119
                    ]
                }
            ],
            "insert_messages_one": [
                102,
                {
                    "object": [
                        125,
                        "messages_insert_input!"
                    ],
                    "on_conflict": [
                        132
                    ]
                }
            ],
            "insert_messages_to": [
                146,
                {
                    "objects": [
                        143,
                        "[messages_to_insert_input!]!"
                    ],
                    "on_conflict": [
                        148
                    ]
                }
            ],
            "insert_messages_to_one": [
                139,
                {
                    "object": [
                        143,
                        "messages_to_insert_input!"
                    ],
                    "on_conflict": [
                        148
                    ]
                }
            ],
            "insert_products": [
                219,
                {
                    "objects": [
                        214,
                        "[products_insert_input!]!"
                    ],
                    "on_conflict": [
                        221
                    ]
                }
            ],
            "insert_products_extras": [
                195,
                {
                    "objects": [
                        192,
                        "[products_extras_insert_input!]!"
                    ],
                    "on_conflict": [
                        197
                    ]
                }
            ],
            "insert_products_extras_one": [
                185,
                {
                    "object": [
                        192,
                        "products_extras_insert_input!"
                    ],
                    "on_conflict": [
                        197
                    ]
                }
            ],
            "insert_products_one": [
                172,
                {
                    "object": [
                        214,
                        "products_insert_input!"
                    ],
                    "on_conflict": [
                        221
                    ]
                }
            ],
            "insert_seller_products_standard_sizes": [
                256,
                {
                    "objects": [
                        253,
                        "[seller_products_standard_sizes_insert_input!]!"
                    ],
                    "on_conflict": [
                        258
                    ]
                }
            ],
            "insert_seller_products_standard_sizes_one": [
                248,
                {
                    "object": [
                        253,
                        "seller_products_standard_sizes_insert_input!"
                    ],
                    "on_conflict": [
                        258
                    ]
                }
            ],
            "insert_shipment": [
                3,
                {
                    "payload": [
                        99,
                        "jsonb!"
                    ],
                    "return_fields": [
                        99
                    ]
                }
            ],
            "insert_shipment_product_item_extras": [
                380,
                {
                    "objects": [
                        377,
                        "[shipment_product_item_extras_insert_input!]!"
                    ],
                    "on_conflict": [
                        381
                    ]
                }
            ],
            "insert_shipment_product_item_extras_one": [
                370,
                {
                    "object": [
                        377,
                        "shipment_product_item_extras_insert_input!"
                    ],
                    "on_conflict": [
                        381
                    ]
                }
            ],
            "insert_shipment_products_items": [
                414,
                {
                    "objects": [
                        409,
                        "[shipment_products_items_insert_input!]!"
                    ],
                    "on_conflict": [
                        416
                    ]
                }
            ],
            "insert_shipment_products_items_one": [
                397,
                {
                    "object": [
                        409,
                        "shipment_products_items_insert_input!"
                    ],
                    "on_conflict": [
                        416
                    ]
                }
            ],
            "insert_shipments_boxes": [
                462,
                {
                    "objects": [
                        459,
                        "[shipments_boxes_insert_input!]!"
                    ],
                    "on_conflict": [
                        463
                    ]
                }
            ],
            "insert_shipments_boxes_one": [
                453,
                {
                    "object": [
                        459,
                        "shipments_boxes_insert_input!"
                    ],
                    "on_conflict": [
                        463
                    ]
                }
            ],
            "insert_undefined_buyers": [
                586,
                {
                    "objects": [
                        585,
                        "[undefined_buyers_insert_input!]!"
                    ],
                    "on_conflict": [
                        588
                    ]
                }
            ],
            "insert_undefined_buyers_one": [
                582,
                {
                    "object": [
                        585,
                        "undefined_buyers_insert_input!"
                    ],
                    "on_conflict": [
                        588
                    ]
                }
            ],
            "request_shipment_status_change": [
                3,
                {
                    "payload": [
                        99,
                        "jsonb!"
                    ],
                    "return_fields": [
                        99
                    ],
                    "shipment_id": [
                        7,
                        "String!"
                    ]
                }
            ],
            "send_shipment_invoice_on_whatsapp": [
                6,
                {
                    "shipment_id": [
                        7,
                        "String!"
                    ]
                }
            ],
            "update_addresses": [
                19,
                {
                    "_set": [
                        24
                    ],
                    "where": [
                        14,
                        "addresses_bool_exp!"
                    ]
                }
            ],
            "update_addresses_by_pk": [
                11,
                {
                    "_set": [
                        24
                    ],
                    "pk_columns": [
                        22,
                        "addresses_pk_columns_input!"
                    ]
                }
            ],
            "update_addresses_many": [
                19,
                {
                    "updates": [
                        28,
                        "[addresses_updates!]!"
                    ]
                }
            ],
            "update_messages": [
                130,
                {
                    "_set": [
                        136
                    ],
                    "where": [
                        108,
                        "messages_bool_exp!"
                    ]
                }
            ],
            "update_messages_by_pk": [
                102,
                {
                    "_set": [
                        136
                    ],
                    "pk_columns": [
                        134,
                        "messages_pk_columns_input!"
                    ]
                }
            ],
            "update_messages_many": [
                130,
                {
                    "updates": [
                        155,
                        "[messages_updates!]!"
                    ]
                }
            ],
            "update_products": [
                219,
                {
                    "_inc": [
                        213
                    ],
                    "_set": [
                        227
                    ],
                    "where": [
                        183,
                        "products_bool_exp!"
                    ]
                }
            ],
            "update_products_by_pk": [
                172,
                {
                    "_inc": [
                        213
                    ],
                    "_set": [
                        227
                    ],
                    "pk_columns": [
                        223,
                        "products_pk_columns_input!"
                    ]
                }
            ],
            "update_products_extras": [
                195,
                {
                    "_inc": [
                        191
                    ],
                    "_set": [
                        201
                    ],
                    "where": [
                        189,
                        "products_extras_bool_exp!"
                    ]
                }
            ],
            "update_products_extras_by_pk": [
                185,
                {
                    "_inc": [
                        191
                    ],
                    "_set": [
                        201
                    ],
                    "pk_columns": [
                        199,
                        "products_extras_pk_columns_input!"
                    ]
                }
            ],
            "update_products_extras_many": [
                195,
                {
                    "updates": [
                        209,
                        "[products_extras_updates!]!"
                    ]
                }
            ],
            "update_products_many": [
                219,
                {
                    "updates": [
                        239,
                        "[products_updates!]!"
                    ]
                }
            ],
            "update_seller_reviews": [
                284,
                {
                    "_set": [
                        288
                    ],
                    "where": [
                        279,
                        "seller_reviews_bool_exp!"
                    ]
                }
            ],
            "update_seller_reviews_by_pk": [
                271,
                {
                    "_set": [
                        288
                    ],
                    "pk_columns": [
                        286,
                        "seller_reviews_pk_columns_input!"
                    ]
                }
            ],
            "update_seller_reviews_many": [
                284,
                {
                    "updates": [
                        299,
                        "[seller_reviews_updates!]!"
                    ]
                }
            ],
            "update_sellers": [
                313,
                {
                    "_append": [
                        307
                    ],
                    "_delete_at_path": [
                        309
                    ],
                    "_delete_elem": [
                        310
                    ],
                    "_delete_key": [
                        311
                    ],
                    "_inc": [
                        312
                    ],
                    "_prepend": [
                        347
                    ],
                    "_set": [
                        349
                    ],
                    "where": [
                        308,
                        "sellers_bool_exp!"
                    ]
                }
            ],
            "update_sellers_by_pk": [
                306,
                {
                    "_append": [
                        307
                    ],
                    "_delete_at_path": [
                        309
                    ],
                    "_delete_elem": [
                        310
                    ],
                    "_delete_key": [
                        311
                    ],
                    "_inc": [
                        312
                    ],
                    "_prepend": [
                        347
                    ],
                    "_set": [
                        349
                    ],
                    "pk_columns": [
                        346,
                        "sellers_pk_columns_input!"
                    ]
                }
            ],
            "update_sellers_many": [
                313,
                {
                    "updates": [
                        352,
                        "[sellers_updates!]!"
                    ]
                }
            ],
            "update_sellers_users": [
                358,
                {
                    "_set": [
                        362
                    ],
                    "where": [
                        355,
                        "sellers_users_bool_exp!"
                    ]
                }
            ],
            "update_sellers_users_by_pk": [
                353,
                {
                    "_set": [
                        362
                    ],
                    "pk_columns": [
                        360,
                        "sellers_users_pk_columns_input!"
                    ]
                }
            ],
            "update_sellers_users_many": [
                358,
                {
                    "updates": [
                        365,
                        "[sellers_users_updates!]!"
                    ]
                }
            ],
            "update_shipment_product_item_extras": [
                380,
                {
                    "_inc": [
                        376
                    ],
                    "_set": [
                        385
                    ],
                    "where": [
                        374,
                        "shipment_product_item_extras_bool_exp!"
                    ]
                }
            ],
            "update_shipment_product_item_extras_by_pk": [
                370,
                {
                    "_inc": [
                        376
                    ],
                    "_set": [
                        385
                    ],
                    "pk_columns": [
                        383,
                        "shipment_product_item_extras_pk_columns_input!"
                    ]
                }
            ],
            "update_shipment_product_item_extras_many": [
                380,
                {
                    "updates": [
                        393,
                        "[shipment_product_item_extras_updates!]!"
                    ]
                }
            ],
            "update_shipment_products_items": [
                414,
                {
                    "_inc": [
                        408
                    ],
                    "_set": [
                        420
                    ],
                    "where": [
                        406,
                        "shipment_products_items_bool_exp!"
                    ]
                }
            ],
            "update_shipment_products_items_by_pk": [
                397,
                {
                    "_inc": [
                        408
                    ],
                    "_set": [
                        420
                    ],
                    "pk_columns": [
                        418,
                        "shipment_products_items_pk_columns_input!"
                    ]
                }
            ],
            "update_shipment_products_items_many": [
                414,
                {
                    "updates": [
                        432,
                        "[shipment_products_items_updates!]!"
                    ]
                }
            ],
            "update_shipments": [
                487,
                {
                    "_append": [
                        449
                    ],
                    "_delete_at_path": [
                        479
                    ],
                    "_delete_elem": [
                        480
                    ],
                    "_delete_key": [
                        481
                    ],
                    "_inc": [
                        482
                    ],
                    "_prepend": [
                        516
                    ],
                    "_set": [
                        546
                    ],
                    "where": [
                        452,
                        "shipments_bool_exp!"
                    ]
                }
            ],
            "update_shipments_boxes": [
                462,
                {
                    "_inc": [
                        458
                    ],
                    "_set": [
                        467
                    ],
                    "where": [
                        456,
                        "shipments_boxes_bool_exp!"
                    ]
                }
            ],
            "update_shipments_boxes_by_pk": [
                453,
                {
                    "_inc": [
                        458
                    ],
                    "_set": [
                        467
                    ],
                    "pk_columns": [
                        465,
                        "shipments_boxes_pk_columns_input!"
                    ]
                }
            ],
            "update_shipments_boxes_many": [
                462,
                {
                    "updates": [
                        475,
                        "[shipments_boxes_updates!]!"
                    ]
                }
            ],
            "update_shipments_by_pk": [
                441,
                {
                    "_append": [
                        449
                    ],
                    "_delete_at_path": [
                        479
                    ],
                    "_delete_elem": [
                        480
                    ],
                    "_delete_key": [
                        481
                    ],
                    "_inc": [
                        482
                    ],
                    "_prepend": [
                        516
                    ],
                    "_set": [
                        546
                    ],
                    "pk_columns": [
                        515,
                        "shipments_pk_columns_input!"
                    ]
                }
            ],
            "update_shipments_many": [
                487,
                {
                    "updates": [
                        557,
                        "[shipments_updates!]!"
                    ]
                }
            ],
            "update_user_password": [
                3,
                {
                    "old_password": [
                        7,
                        "String!"
                    ],
                    "updated_password": [
                        7,
                        "String!"
                    ]
                }
            ],
            "__typename": [
                7
            ]
        },
        "Subscription": {
            "addresses": [
                11,
                {
                    "distinct_on": [
                        23,
                        "[addresses_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        21,
                        "[addresses_order_by!]"
                    ],
                    "where": [
                        14
                    ]
                }
            ],
            "addresses_by_pk": [
                11,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "addresses_stream": [
                11,
                {
                    "batch_size": [
                        4,
                        "Int!"
                    ],
                    "cursor": [
                        25,
                        "[addresses_stream_cursor_input]!"
                    ],
                    "where": [
                        14
                    ]
                }
            ],
            "buyers": [
                31,
                {
                    "distinct_on": [
                        34,
                        "[buyers_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        33,
                        "[buyers_order_by!]"
                    ],
                    "where": [
                        32
                    ]
                }
            ],
            "buyers_by_pk": [
                31,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "buyers_stream": [
                31,
                {
                    "batch_size": [
                        4,
                        "Int!"
                    ],
                    "cursor": [
                        35,
                        "[buyers_stream_cursor_input]!"
                    ],
                    "where": [
                        32
                    ]
                }
            ],
            "drivers": [
                40,
                {
                    "distinct_on": [
                        60,
                        "[drivers_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        59,
                        "[drivers_order_by!]"
                    ],
                    "where": [
                        41
                    ]
                }
            ],
            "drivers_by_pk": [
                40,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "drivers_locations": [
                42,
                {
                    "distinct_on": [
                        49,
                        "[drivers_locations_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        48,
                        "[drivers_locations_order_by!]"
                    ],
                    "where": [
                        45
                    ]
                }
            ],
            "drivers_locations_by_pk": [
                42,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "drivers_locations_stream": [
                42,
                {
                    "batch_size": [
                        4,
                        "Int!"
                    ],
                    "cursor": [
                        53,
                        "[drivers_locations_stream_cursor_input]!"
                    ],
                    "where": [
                        45
                    ]
                }
            ],
            "drivers_stream": [
                40,
                {
                    "batch_size": [
                        4,
                        "Int!"
                    ],
                    "cursor": [
                        61,
                        "[drivers_stream_cursor_input]!"
                    ],
                    "where": [
                        41
                    ]
                }
            ],
            "env_variables": [
                65,
                {
                    "distinct_on": [
                        68,
                        "[env_variables_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        67,
                        "[env_variables_order_by!]"
                    ],
                    "where": [
                        66
                    ]
                }
            ],
            "env_variables_by_pk": [
                65,
                {
                    "key": [
                        7,
                        "String!"
                    ]
                }
            ],
            "env_variables_stream": [
                65,
                {
                    "batch_size": [
                        4,
                        "Int!"
                    ],
                    "cursor": [
                        69,
                        "[env_variables_stream_cursor_input]!"
                    ],
                    "where": [
                        66
                    ]
                }
            ],
            "food_categories": [
                73,
                {
                    "distinct_on": [
                        90,
                        "[food_categories_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        75,
                        "[food_categories_order_by!]"
                    ],
                    "where": [
                        74
                    ]
                }
            ],
            "food_categories_by_pk": [
                73,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "food_categories_products": [
                76,
                {
                    "distinct_on": [
                        86,
                        "[food_categories_products_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        85,
                        "[food_categories_products_order_by!]"
                    ],
                    "where": [
                        78
                    ]
                }
            ],
            "food_categories_products_by_pk": [
                76,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "food_categories_products_stream": [
                76,
                {
                    "batch_size": [
                        4,
                        "Int!"
                    ],
                    "cursor": [
                        87,
                        "[food_categories_products_stream_cursor_input]!"
                    ],
                    "where": [
                        78
                    ]
                }
            ],
            "food_categories_stream": [
                73,
                {
                    "batch_size": [
                        4,
                        "Int!"
                    ],
                    "cursor": [
                        91,
                        "[food_categories_stream_cursor_input]!"
                    ],
                    "where": [
                        74
                    ]
                }
            ],
            "messages": [
                102,
                {
                    "distinct_on": [
                        135,
                        "[messages_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        133,
                        "[messages_order_by!]"
                    ],
                    "where": [
                        108
                    ]
                }
            ],
            "messages_aggregate": [
                103,
                {
                    "distinct_on": [
                        135,
                        "[messages_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        133,
                        "[messages_order_by!]"
                    ],
                    "where": [
                        108
                    ]
                }
            ],
            "messages_by_pk": [
                102,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "messages_from": [
                110,
                {
                    "distinct_on": [
                        121,
                        "[messages_from_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        120,
                        "[messages_from_order_by!]"
                    ],
                    "where": [
                        112
                    ]
                }
            ],
            "messages_from_by_pk": [
                110,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "messages_from_stream": [
                110,
                {
                    "batch_size": [
                        4,
                        "Int!"
                    ],
                    "cursor": [
                        122,
                        "[messages_from_stream_cursor_input]!"
                    ],
                    "where": [
                        112
                    ]
                }
            ],
            "messages_stream": [
                102,
                {
                    "batch_size": [
                        4,
                        "Int!"
                    ],
                    "cursor": [
                        137,
                        "[messages_stream_cursor_input]!"
                    ],
                    "where": [
                        108
                    ]
                }
            ],
            "messages_to": [
                139,
                {
                    "distinct_on": [
                        150,
                        "[messages_to_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        149,
                        "[messages_to_order_by!]"
                    ],
                    "where": [
                        141
                    ]
                }
            ],
            "messages_to_by_pk": [
                139,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "messages_to_stream": [
                139,
                {
                    "batch_size": [
                        4,
                        "Int!"
                    ],
                    "cursor": [
                        151,
                        "[messages_to_stream_cursor_input]!"
                    ],
                    "where": [
                        141
                    ]
                }
            ],
            "operators": [
                158,
                {
                    "distinct_on": [
                        161,
                        "[operators_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        160,
                        "[operators_order_by!]"
                    ],
                    "where": [
                        159
                    ]
                }
            ],
            "operators_by_pk": [
                158,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "operators_stream": [
                158,
                {
                    "batch_size": [
                        4,
                        "Int!"
                    ],
                    "cursor": [
                        162,
                        "[operators_stream_cursor_input]!"
                    ],
                    "where": [
                        159
                    ]
                }
            ],
            "products": [
                172,
                {
                    "distinct_on": [
                        224,
                        "[products_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        222,
                        "[products_order_by!]"
                    ],
                    "where": [
                        183
                    ]
                }
            ],
            "products_aggregate": [
                173,
                {
                    "distinct_on": [
                        224,
                        "[products_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        222,
                        "[products_order_by!]"
                    ],
                    "where": [
                        183
                    ]
                }
            ],
            "products_by_pk": [
                172,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "products_extras": [
                185,
                {
                    "distinct_on": [
                        200,
                        "[products_extras_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        198,
                        "[products_extras_order_by!]"
                    ],
                    "where": [
                        189
                    ]
                }
            ],
            "products_extras_by_pk": [
                185,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "products_extras_stream": [
                185,
                {
                    "batch_size": [
                        4,
                        "Int!"
                    ],
                    "cursor": [
                        205,
                        "[products_extras_stream_cursor_input]!"
                    ],
                    "where": [
                        189
                    ]
                }
            ],
            "products_stream": [
                172,
                {
                    "batch_size": [
                        4,
                        "Int!"
                    ],
                    "cursor": [
                        234,
                        "[products_stream_cursor_input]!"
                    ],
                    "where": [
                        183
                    ]
                }
            ],
            "seller_products_standard_sizes": [
                248,
                {
                    "distinct_on": [
                        260,
                        "[seller_products_standard_sizes_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        259,
                        "[seller_products_standard_sizes_order_by!]"
                    ],
                    "where": [
                        251
                    ]
                }
            ],
            "seller_products_standard_sizes_by_pk": [
                248,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "seller_products_standard_sizes_stream": [
                248,
                {
                    "batch_size": [
                        4,
                        "Int!"
                    ],
                    "cursor": [
                        264,
                        "[seller_products_standard_sizes_stream_cursor_input]!"
                    ],
                    "where": [
                        251
                    ]
                }
            ],
            "seller_reviews": [
                271,
                {
                    "distinct_on": [
                        287,
                        "[seller_reviews_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        285,
                        "[seller_reviews_order_by!]"
                    ],
                    "where": [
                        279
                    ]
                }
            ],
            "seller_reviews_aggregate": [
                272,
                {
                    "distinct_on": [
                        287,
                        "[seller_reviews_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        285,
                        "[seller_reviews_order_by!]"
                    ],
                    "where": [
                        279
                    ]
                }
            ],
            "seller_reviews_by_pk": [
                271,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "seller_reviews_stream": [
                271,
                {
                    "batch_size": [
                        4,
                        "Int!"
                    ],
                    "cursor": [
                        295,
                        "[seller_reviews_stream_cursor_input]!"
                    ],
                    "where": [
                        279
                    ]
                }
            ],
            "sellers": [
                306,
                {
                    "distinct_on": [
                        348,
                        "[sellers_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        314,
                        "[sellers_order_by!]"
                    ],
                    "where": [
                        308
                    ]
                }
            ],
            "sellers_by_pk": [
                306,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "sellers_payouts_receipts_out": [
                315,
                {
                    "distinct_on": [
                        329,
                        "[sellers_payouts_receipts_out_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        328,
                        "[sellers_payouts_receipts_out_order_by!]"
                    ],
                    "where": [
                        323
                    ]
                }
            ],
            "sellers_payouts_receipts_out_aggregate": [
                316,
                {
                    "distinct_on": [
                        329,
                        "[sellers_payouts_receipts_out_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        328,
                        "[sellers_payouts_receipts_out_order_by!]"
                    ],
                    "where": [
                        323
                    ]
                }
            ],
            "sellers_payouts_receipts_out_by_pk": [
                315,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "sellers_payouts_receipts_out_stream": [
                315,
                {
                    "batch_size": [
                        4,
                        "Int!"
                    ],
                    "cursor": [
                        336,
                        "[sellers_payouts_receipts_out_stream_cursor_input]!"
                    ],
                    "where": [
                        323
                    ]
                }
            ],
            "sellers_stream": [
                306,
                {
                    "batch_size": [
                        4,
                        "Int!"
                    ],
                    "cursor": [
                        350,
                        "[sellers_stream_cursor_input]!"
                    ],
                    "where": [
                        308
                    ]
                }
            ],
            "sellers_users": [
                353,
                {
                    "distinct_on": [
                        361,
                        "[sellers_users_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        359,
                        "[sellers_users_order_by!]"
                    ],
                    "where": [
                        355
                    ]
                }
            ],
            "sellers_users_by_pk": [
                353,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "sellers_users_stream": [
                353,
                {
                    "batch_size": [
                        4,
                        "Int!"
                    ],
                    "cursor": [
                        363,
                        "[sellers_users_stream_cursor_input]!"
                    ],
                    "where": [
                        355
                    ]
                }
            ],
            "shipment_product_item_extras": [
                370,
                {
                    "distinct_on": [
                        384,
                        "[shipment_product_item_extras_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        382,
                        "[shipment_product_item_extras_order_by!]"
                    ],
                    "where": [
                        374
                    ]
                }
            ],
            "shipment_product_item_extras_by_pk": [
                370,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "shipment_product_item_extras_stream": [
                370,
                {
                    "batch_size": [
                        4,
                        "Int!"
                    ],
                    "cursor": [
                        389,
                        "[shipment_product_item_extras_stream_cursor_input]!"
                    ],
                    "where": [
                        374
                    ]
                }
            ],
            "shipment_products_items": [
                397,
                {
                    "distinct_on": [
                        419,
                        "[shipment_products_items_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        417,
                        "[shipment_products_items_order_by!]"
                    ],
                    "where": [
                        406
                    ]
                }
            ],
            "shipment_products_items_aggregate": [
                398,
                {
                    "distinct_on": [
                        419,
                        "[shipment_products_items_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        417,
                        "[shipment_products_items_order_by!]"
                    ],
                    "where": [
                        406
                    ]
                }
            ],
            "shipment_products_items_by_pk": [
                397,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "shipment_products_items_stream": [
                397,
                {
                    "batch_size": [
                        4,
                        "Int!"
                    ],
                    "cursor": [
                        427,
                        "[shipment_products_items_stream_cursor_input]!"
                    ],
                    "where": [
                        406
                    ]
                }
            ],
            "shipments": [
                441,
                {
                    "distinct_on": [
                        543,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        497,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        452
                    ]
                }
            ],
            "shipments_aggregate": [
                442,
                {
                    "distinct_on": [
                        543,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        497,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        452
                    ]
                }
            ],
            "shipments_boxes": [
                453,
                {
                    "distinct_on": [
                        466,
                        "[shipments_boxes_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        464,
                        "[shipments_boxes_order_by!]"
                    ],
                    "where": [
                        456
                    ]
                }
            ],
            "shipments_boxes_by_pk": [
                453,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "shipments_boxes_stream": [
                453,
                {
                    "batch_size": [
                        4,
                        "Int!"
                    ],
                    "cursor": [
                        471,
                        "[shipments_boxes_stream_cursor_input]!"
                    ],
                    "where": [
                        456
                    ]
                }
            ],
            "shipments_by_pk": [
                441,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "shipments_notes": [
                488,
                {
                    "distinct_on": [
                        494,
                        "[shipments_notes_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        493,
                        "[shipments_notes_order_by!]"
                    ],
                    "where": [
                        490
                    ]
                }
            ],
            "shipments_notes_stream": [
                488,
                {
                    "batch_size": [
                        4,
                        "Int!"
                    ],
                    "cursor": [
                        495,
                        "[shipments_notes_stream_cursor_input]!"
                    ],
                    "where": [
                        490
                    ]
                }
            ],
            "shipments_payments": [
                498,
                {
                    "distinct_on": [
                        505,
                        "[shipments_payments_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        504,
                        "[shipments_payments_order_by!]"
                    ],
                    "where": [
                        501
                    ]
                }
            ],
            "shipments_payments_by_pk": [
                498,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "shipments_payments_stream": [
                498,
                {
                    "batch_size": [
                        4,
                        "Int!"
                    ],
                    "cursor": [
                        509,
                        "[shipments_payments_stream_cursor_input]!"
                    ],
                    "where": [
                        501
                    ]
                }
            ],
            "shipments_routes_steps": [
                517,
                {
                    "distinct_on": [
                        523,
                        "[shipments_routes_steps_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        522,
                        "[shipments_routes_steps_order_by!]"
                    ],
                    "where": [
                        519
                    ]
                }
            ],
            "shipments_routes_steps_by_pk": [
                517,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "shipments_routes_steps_shipments": [
                524,
                {
                    "distinct_on": [
                        531,
                        "[shipments_routes_steps_shipments_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        530,
                        "[shipments_routes_steps_shipments_order_by!]"
                    ],
                    "where": [
                        527
                    ]
                }
            ],
            "shipments_routes_steps_shipments_by_pk": [
                524,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "shipments_routes_steps_shipments_stream": [
                524,
                {
                    "batch_size": [
                        4,
                        "Int!"
                    ],
                    "cursor": [
                        535,
                        "[shipments_routes_steps_shipments_stream_cursor_input]!"
                    ],
                    "where": [
                        527
                    ]
                }
            ],
            "shipments_routes_steps_stream": [
                517,
                {
                    "batch_size": [
                        4,
                        "Int!"
                    ],
                    "cursor": [
                        541,
                        "[shipments_routes_steps_stream_cursor_input]!"
                    ],
                    "where": [
                        519
                    ]
                }
            ],
            "shipments_stream": [
                441,
                {
                    "batch_size": [
                        4,
                        "Int!"
                    ],
                    "cursor": [
                        553,
                        "[shipments_stream_cursor_input]!"
                    ],
                    "where": [
                        452
                    ]
                }
            ],
            "shipping_cost_per_city": [
                566,
                {
                    "distinct_on": [
                        569,
                        "[shipping_cost_per_city_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        568,
                        "[shipping_cost_per_city_order_by!]"
                    ],
                    "where": [
                        567
                    ]
                }
            ],
            "shipping_cost_per_city_by_pk": [
                566,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "shipping_cost_per_city_stream": [
                566,
                {
                    "batch_size": [
                        4,
                        "Int!"
                    ],
                    "cursor": [
                        570,
                        "[shipping_cost_per_city_stream_cursor_input]!"
                    ],
                    "where": [
                        567
                    ]
                }
            ],
            "undefined_buyers": [
                582,
                {
                    "distinct_on": [
                        590,
                        "[undefined_buyers_select_column!]"
                    ],
                    "limit": [
                        4
                    ],
                    "offset": [
                        4
                    ],
                    "order_by": [
                        589,
                        "[undefined_buyers_order_by!]"
                    ],
                    "where": [
                        583
                    ]
                }
            ],
            "undefined_buyers_by_pk": [
                582,
                {
                    "id": [
                        596,
                        "uuid!"
                    ]
                }
            ],
            "undefined_buyers_stream": [
                582,
                {
                    "batch_size": [
                        4,
                        "Int!"
                    ],
                    "cursor": [
                        591,
                        "[undefined_buyers_stream_cursor_input]!"
                    ],
                    "where": [
                        583
                    ]
                }
            ],
            "__typename": [
                7
            ]
        }
    }
}